<template>
  <div class="container" style="overflow: hidden">
    <!-- 挑选到 -->
    <el-dialog width="30%" title="添加类型" :visible.sync="innerVisible">
      <el-radio v-model="is_typeof_add_to" label="0">课前</el-radio>
      <el-radio v-model="is_typeof_add_to" label="1">课中</el-radio>
      <el-radio v-model="is_typeof_add_to" label="2">课后</el-radio>
      <!-- this.add_homework_material_dia=true -->
      <span slot="footer" class="dialog-footer" v-if="edit_material_item_type != 'pre'">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            innerVisible = false;
            add_homework_material_dia = true;
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog width="30%" title="修改类型" :visible.sync="innerVisible_update">
      <el-radio v-model="is_typeof_add_to" label="0">课前</el-radio>
      <el-radio v-model="is_typeof_add_to" label="1">课中</el-radio>
      <el-radio v-model="is_typeof_add_to" label="2">课后</el-radio>
      <!-- this.add_homework_material_dia=true -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible_update = false">取 消</el-button>
        <el-button type="primary" @click="onInnerVisible_update">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加到 -->
    <el-dialog width="30%" title="添加类型" :visible.sync="innerVisible_add">
      <el-radio v-model="is_typeof_add_to" label="0">课前</el-radio>
      <el-radio v-model="is_typeof_add_to" label="1">课中</el-radio>
      <el-radio v-model="is_typeof_add_to" label="2">课后</el-radio>
      <!-- this.add_homework_material_dia=true -->
      <span slot="footer" class="dialog-footer" v-if="edit_material_item_type != 'pre'">
        <el-button @click="innerVisible_add = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            innerVisible_add = false;
            dialogVisible_add_material = true;
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog width="30%" title="添加类型" :visible.sync="innerVisible_add_homework">
      <el-radio v-model="is_typeof_add_to" label="0">课前</el-radio>
      <el-radio v-model="is_typeof_add_to" label="1">课中</el-radio>
      <el-radio v-model="is_typeof_add_to" label="2">课后</el-radio>
      <!-- this.add_homework_material_dia=true -->
      <span slot="footer" class="dialog-footer" v-if="edit_material_item_type != 'pre'">
        <el-button @click="innerVisible_add_homework = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            innerVisible_add_homework = false;
            $router.push('/course/creat_homework?is_course_type=' + is_typeof_add_to);
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="资料"
      :visible.sync="dialogVisible_add_material"
      custom-class="dialogVisible_add_material"
      width="50%"
      :close-on-click-modal="false"
    >
      <div class="add_material_contnet">
        <div
          class="add_course_info_head_course_name_add_name"
          style="display: flex; align-items: center"
        >
          <div>资料名称</div>
          <div v-if="edit_material_item_type == 'pre'">
            {{ add_material_name }}
          </div>
          <div v-if="edit_material_item_type != 'pre'">
            <el-input v-model="add_material_name" placeholder="请输入资料名称"></el-input>
          </div>

          <el-checkbox
            v-model="status_course"
            class="add_course_info_head_course_name_myself"
            style="color: #999999; margin-left: auto"
            >仅自己可见</el-checkbox
          >
        </div>
        <div
          v-if="edit_material_item_type == 'pre'"
          class="edit_material_item_type_name"
        ></div>
        <div>
          <div v-if="edit_material_item_type != 'pre'">
            <div class="add_material_content_head">上传文件</div>

            <!-- <div v-if="add_material_list.length==0" class="add_material_content_btn">选择文件</div> -->
          </div>

          <!--  -->
          <uploader
            v-if="edit_material_item_type != 'pre'"
            :options="options_add_material"
            class="uploader-example"
            @file-progress="onFileProgress"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            ref="uploader"
          >
            <uploader-unsupport></uploader-unsupport>
            <!-- <uploader-drop  v-if="add_material_list.length==0"> -->
            <uploader-drop>
              <!-- <uploader-btn single >选择文件</uploader-btn> -->
              <uploader-btn>选择文件</uploader-btn>
              <!-- <el-progress v-if="show_progress"  :percentage="ispercentage" ></el-progress> -->
            </uploader-drop>
            <uploader-list>
              <ul class="file-list" slot-scope="props">
                <li v-for="file in props.fileList" :key="file.id">
                  <uploader-file
                    v-if="show_progress"
                    :class="'file_' + file.id"
                    ref="files"
                    :file="file"
                    :list="true"
                  ></uploader-file>
                  <!-- <div>{{file}}</div> -->
                </li>
                <!-- <div class="no-file" v-if="!props.fileList.length"><i class="nucfont inuc-empty-file"></i> 暂无待上传文件</div> -->
              </ul>
            </uploader-list>
            <div style="opacity: 0">列表</div>
          </uploader>

          <!--  -->
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="add_course_info_content_box_content_item"
              @click="prew_material(item_f)"
              v-for="(item_f, index_f) in add_material_list"
              :key="index_f + 'f'"
            >
              <div class="add_course_info_content_box_content_item_img">
                <div
                  class="add_course_info_content_box_content_item_del"
                  v-if="edit_material_item_type != 'pre'"
                  @click.stop="
                    $confirm('确认删除？')
                      .then((_) => {
                        add_material_list.splice(index_f, 1);
                      })
                      .catch((_) => {})
                  "
                >
                  <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
                </div>
                <img
                  v-if="
                    item_f.type == 'png' ||
                    item_f.type == 'jpg' ||
                    item_f.type == 'gif' ||
                    item_f.type == 'jpeg'
                  "
                  src="../../assets/images/course_2.0/图片.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                  src="../../assets/images/course_2.0/pdf.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item_f.type == 'ppt' ||
                    item_f.type == 'pptx' ||
                    item_f.type == 'PPT' ||
                    item_f.type == 'PPTX'
                  "
                  src="../../assets/images/course_2.0/PPT.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item_f.type == 'doc' ||
                    item_f.type == 'DOC' ||
                    item_f.type == 'docx' ||
                    item_f.type == 'DOCX'
                  "
                  src="../../assets/images/course_2.0/word.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                  src="../../assets/images/course_2.0/excel.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                  src="../../assets/images/course_2.0/音频.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />

                <img
                  v-if="
                    item_f.type == 'mp4' ||
                    item_f.type == 'MP4' ||
                    item_f.type == 'wmv' ||
                    item_f.type == 'WMV' ||
                    item_f.type == 'mpg' ||
                    item_f.type == 'MPG' ||
                    item_f.type == 'avi' ||
                    item_f.type == 'AVI' ||
                    item_f.type == 'swf' ||
                    item_f.type == 'SWF' ||
                    item_f.type == 'flv' ||
                    item_f.type == 'FLV'
                  "
                  src="../../assets/images/course_2.0/视频.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
              </div>
              <div class="add_course_info_content_box_content_item_txt">
                {{ item_f.name || item_f.title || "" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="edit_material_item_type != 'pre'">
        <el-button @click="dialogVisible_add_material = false">取 消</el-button>
        <el-button type="primary" @click="save_add_material()">确 定</el-button>
      </span>

      <!-- <homeTimetable :from="'course'" :chooseday_index='chooseday_index' :arr_to_classtable='arr_to_classtable' v-if="dialogVisible_classtable"></homeTimetable> -->
    </el-dialog>
    <!-- 预览 -->
    <el-dialog
      :title="'预览：' + (prew_content.name || prew_content.title)"
      :visible.sync="dialogVisible_previewData"
      width="50%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
    >
      <previewData
        v-if="dialogVisible_previewData"
        :prew_type="prew_type"
        :prew_content="prew_content"
        :from_name="from_name"
      ></previewData>
    </el-dialog>
    <el-dialog
      :title="
        new_add_type == 'homework'
          ? '添加作业'
          : new_add_type == 'material'
          ? '添加资料'
          : new_add_type == 'courseware'
          ? '添加课件'
          : new_add_type == 'video'
          ? '添加视频'
          : new_add_type == 'exam'
          ? '添加考卷'
          : new_add_type == 'teaching'
          ? '添加教案'
          : '添加导学案'
      "
      :visible.sync="add_homework_material_dia"
      custom-class="sign_course_edit_rich_guide_dia"
    >
      <div class="add_dia_all">
        <div>
          <div class="add_dia_type_bar">
            <div class="add_dia_type_bar_type">
              <div
                v-for="(item, index) in tap_list"
                :key="index"
                class="add_dia_type_bar_type_item"
                @click="
                  pageNum = 1;
                  choose_tab_active(index);
                "
              >
                <div>
                  {{
                    item +
                    (new_add_type == "homework"
                      ? "作业"
                      : new_add_type == "material"
                      ? "资料"
                      : new_add_type == "courseware"
                      ? "课件"
                      : new_add_type == "video"
                      ? "视频"
                      : new_add_type == "exam"
                      ? "考卷"
                      : new_add_type == "teaching"
                      ? "教案"
                      : "导学案")
                  }}
                </div>
                <div
                  class="add_dia_type_bar_type_underline"
                  :style="{ opacity: index === tab_active ? 1 : 0 }"
                ></div>
              </div>
            </div>
            <!-- <div class="add_dia_type_bar_addNew">
            <div v-if="new_add_type=='material'">本地上传</div>
            <div v-if="new_add_type=='homework'">创建作业</div>
          </div> -->
          </div>
          <div class="add_dia_search_bar">
            <div class="course_search">
              <el-input
                placeholder="请输入名称"
                v-model="search_data"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    pageNum = 1;
                    choose_tab_active(tab_active);
                  "
                  style="border-radius: 50%"
                ></el-button>
              </el-input>
            </div>
            <div class="sort_box">
              <!-- 课件 -->
              <!-- <div>
              <div class="course_creat_sort">
                  <div>
                    <el-popover
                      placement="bottom"
                      trigger="click"
                      popper-class="area_popper_course"
                      v-model='popover_sort_show'
                      >
                      <div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{sort_time}}-{{sort_type}} <i :class="popover_sort_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
                      <div class='course_creat_sort_options'>
                        <div class='course_creat_sort_options_disable'>查看范围</div>
                        <div :class="{color_active:sort_time=='全部'}" @click="change_sort_time('全部')">全部</div>
                        <div :class="{color_active:sort_time=='最近一周'}" @click="change_sort_time('最近一周')">最近一周</div>
                        <div :class="{color_active:sort_time=='最近一月'}" @click="change_sort_time('最近一月')">最近一月</div>
                        <div :class="{color_active:sort_time=='最近一年'}" @click="change_sort_time('最近一年')">最近一年</div>
                        <div class='course_creat_sort_options_disable'>筛选排序</div>
                        <div :class="{color_active:sort_type=='时间最新'}" @click="change_sort_type('时间最新')">时间最新</div>
                        <div :class="{color_active:sort_type=='时间最早'}" @click="change_sort_type('时间最早')">时间最早</div>
                        <div :class="{color_active:sort_type=='热度最高'}" @click="change_sort_type('热度最高')">热度最高</div>
                        
                      </div>
                    </el-popover>
                  </div>
                  <div class="creat_course" v-if="tab_active==3" @click="add_btn()">
                    创建备课包
                  </div>
                </div>
            </div> -->
              <!-- 排序 -->
              <div>
                <div class="course_creat_sort">
                  <div>
                    <el-popover
                      placement="bottom"
                      trigger="click"
                      popper-class="area_popper_course"
                      v-model="popover_sort_show"
                    >
                      <div
                        slot="reference"
                        class="course_creat_sort_btn"
                        style="cursor: pointer"
                      >
                        {{ sort_time }}-{{ sort_type }}
                        <i
                          :class="
                            popover_sort_show
                              ? 'el-icon-caret-top'
                              : 'el-icon-caret-bottom'
                          "
                        ></i>
                      </div>
                      <div class="course_creat_sort_options">
                        <div class="course_creat_sort_options_disable">查看范围</div>
                        <div
                          :class="{ color_active: sort_time == '全部' }"
                          @click="change_sort_time('全部')"
                        >
                          全部
                        </div>
                        <div
                          :class="{ color_active: sort_time == '最近一周' }"
                          @click="change_sort_time('最近一周')"
                        >
                          最近一周
                        </div>
                        <div
                          :class="{ color_active: sort_time == '最近一月' }"
                          @click="change_sort_time('最近一月')"
                        >
                          最近一月
                        </div>
                        <div
                          :class="{ color_active: sort_time == '最近一年' }"
                          @click="change_sort_time('最近一年')"
                        >
                          最近一年
                        </div>
                        <div class="course_creat_sort_options_disable">筛选排序</div>
                        <div
                          :class="{ color_active: sort_type == '时间最新' }"
                          @click="change_sort_type('时间最新')"
                        >
                          时间最新
                        </div>
                        <div
                          :class="{ color_active: sort_type == '时间最早' }"
                          @click="change_sort_type('时间最早')"
                        >
                          时间最早
                        </div>
                        <div
                          :class="{ color_active: sort_type == '热度最高' }"
                          @click="change_sort_type('热度最高')"
                        >
                          热度最高
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-loading="this.$store.state.isLoading" style="flex: 1; overflow: auto">
          <div class="add_dia_content">
            <div
              class="course_card"
              v-for="(item_m_job, index_m_job) in list_for_choose"
              :key="'m_uuid' + index_m_job"
              @click="choose_card(item_m_job)"
            >
              <div
                class="choose_card el-icon-success"
                :style="{
                  color: !card_in_arr(item_m_job) ? 'transparent' : '#69B4FF',
                }"
              ></div>
              <div class="course_card_title">
                <div class="course_card_title_icon">
                  <img
                    v-if="new_add_type == 'homework'"
                    style="width: 24px"
                    src="../../assets/images/course_2.0/作业.png"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="
                      item_m_job.type == 'png' ||
                      item_m_job.type == 'jpg' ||
                      item_m_job.type == 'gif' ||
                      item_m_job.type == 'jpeg'
                    "
                    src="../../assets/images/course_choose/图片.png"
                    class="add_course_info_content_box_content_item_img_homework"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="item_m_job.type == 'pdf' || item_m_job.type == 'PDF'"
                    src="../../assets/images/course_choose/pdf.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="
                      item_m_job.type == 'ppt' ||
                      item_m_job.type == 'pptx' ||
                      item_m_job.type == 'PPT' ||
                      item_m_job.type == 'PPTX'
                    "
                    src="../../assets/images/course_choose/ppt.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="
                      item_m_job.type == 'doc' ||
                      item_m_job.type == 'DOC' ||
                      item_m_job.type == 'docx' ||
                      item_m_job.type == 'DOCX'
                    "
                    src="../../assets/images/course_choose/word.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="item_m_job.type == 'xls' || item_m_job.type == 'xlsx'"
                    src="../../assets/images/course_choose/excel.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="item_m_job.type == 'mp3' || item_m_job.type == 'MP3'"
                    src="../../assets/images/course_choose/音频.png"
                    class="add_course_info_content_box_content_item_img_ppt"
                    alt=""
                  />
                  <img
                    style="width: 24px; height: 24px"
                    v-if="
                      item_m_job.type == 'mp4' ||
                      item_m_job.type == 'MP4' ||
                      item_m_job.type == 'wmv' ||
                      item_m_job.type == 'WMV' ||
                      item_m_job.type == 'mpg' ||
                      item_m_job.type == 'MPG' ||
                      item_m_job.type == 'avi' ||
                      item_m_job.type == 'AVI' ||
                      item_m_job.type == 'swf' ||
                      item_m_job.type == 'SWF' ||
                      item_m_job.type == 'flv' ||
                      item_m_job.type == 'FLV'
                    "
                    src="../../assets/images/course_choose/视频.png"
                    class="add_course_info_content_box_content_item_img_homework"
                    alt=""
                  />
                </div>
                <div
                  class="course_card_title_name"
                  :title="item_m_job.name || item_m_job.title"
                >
                  {{ item_m_job.name || item_m_job.title }}
                </div>
                <div class="course_card_title_course_heat">
                  <img src="../../assets/images/course_2.0/热度.png" alt="" />{{
                    item_m_job.heat
                  }}
                </div>
              </div>

              <div
                class="course_card_content_item"
                v-if="item_m_job.createtime.toString().length == 10"
              >
                时间：{{ item_m_job.createtime | dataFormat }}
              </div>
              <div class="course_card_content_item" v-else>
                时间：{{ item_m_job.createtime }}
              </div>
              <!-- <div class='course_card_content_item'>
                时间：{{item_m_job.createtime}}
              </div> -->
              <div class="course_card_content_item">
                创建人：{{ item_m_job.from }}-{{ item_m_job.teacher_name }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="course_page" style="text-align: right">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              :total="total"
              @current-change="changePage"
              :current-page="pageNum"
            >
            </el-pagination>
          </div>
          <div class="add_dia_foot" slot="footer">
            <div
              @click="confirm_choose()"
              v-if="new_add_type != 'teaching' && new_add_type != 'guidance'"
            >
              确定
            </div>
            <div @click="confirm_choose_teaching()" v-if="new_add_type == 'teaching'">
              确定
            </div>
            <div @click="confirm_choose_guidance()" v-if="new_add_type == 'guidance'">
              确定
            </div>
            <div @click="add_homework_material_dia = false">取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 预览教案 -->
    <el-dialog :title="'教案预览'" :visible.sync="dialogVisible_t" width="90%">
      <div style="" v-html="teaching_text"></div>
    </el-dialog>
    <!-- 预览导学案 -->
    <el-dialog :title="'导学案预览'" :visible.sync="dialogVisible_g" width="90%">
      <div style="" v-html="guidance_text"></div>
    </el-dialog>
    <!--  -->

    <!-- 2.0 -->
    <div class="wrapper">
      <div class="add_course_head">
        <div @click="goBack">
          <img src="../../assets/images/course_2.0/返回.png" alt="" />
        </div>
        <div>
          {{
            $route.query.name == "预览"
              ? course_name
              : $route.query.name == "编辑"
              ? "编辑备课包"
              : "创建备课包"
          }}
        </div>
        <div class="add_course_head_save">
          <!-- <div style="opacity: 0" v-if="$route.query.name != '预览'">
            保存并创建
          </div> -->
          <!-- <div @click="show_save_course()"  >看下结构</div> -->
          <div @click="save_course()" v-if="$route.query.name != '预览'">
            {{ status_to_examine ? "保存并提交审核" : "保存" }}
          </div>
        </div>
      </div>
      <div class="add_course_info_head">
        <div class="add_course_info_head_course_name" v-if="$route.query.name != '预览'">
          <div class="add_course_info_head_course_name_add_name" style="display: flex">
            <div>备课包名称</div>
            <div>
              <el-input v-model="course_name" placeholder="请输入备课包名称"></el-input>
            </div>
          </div>
          <!-- <div v-if="$route.query.from == 'index'">
            <el-popover
              placement="bottom"
              trigger="click"
              popper-class="area_popper"
              v-model="chapter_popover"
            >
              <div slot="reference" style="display: flex">
                <div class="chapter_bar">
                  章节：<span style="color: #999999"> {{ chapter_name }}</span>
                  <span style="opacity: 0">11</span>
                  <span
                    v-if="!chapter_popover"
                    style="color: #999999"
                    class="el-icon-caret-bottom"
                  ></span>
                  <span
                    v-else
                    style="color: #999999"
                    class="el-icon-caret-top"
                  ></span>
                </div>
              </div>
              <div>
                <el-tree
                  :data="SectionData"
                  :props="SectionProps"
                  @node-click="getSectionData"
                  node-key="guid"
                  :default-expanded-keys="showNode"
                  highlight-current
                  ref="treeBox"
                >
                  <div class="tree_line" slot-scope="{ node }">
                    <div>{{ node.label }}</div>
                  </div>
                </el-tree>
              </div>
            </el-popover>
          </div> -->

          <!-- <div class="flex-row-v-center">
            <div class="flex-row-v-center" style="margin-right: 20px">
              <span style="margin-right: 8px">提审用备课包</span>
              <el-switch
                v-model="status_value"
                active-color="#13ce66"
                inactive-color="#999999"
              >
              </el-switch>
            </div>
            <el-checkbox
              v-show="!status_value"
              v-model="status_course"
              class="add_course_info_head_course_name_myself"
              style="color: #999999"
              >仅自己可见</el-checkbox
            >
            <el-checkbox
              v-show="status_value"
              v-model="status_to_examine"
              class="add_course_info_head_course_name_myself"
              style="color: #999999"
              >立即审核</el-checkbox
            >
            <div v-if="status_to_examine&&status_value" style="margin-left:10px">
              <el-radio v-model="status" label="3">学校备课包</el-radio>
              <el-radio v-model="status" label="10">云端备课包</el-radio>
            </div>

          </div> -->
        </div>
        <div
          class="add_course_info_head_course_name_add_teaching_guide"
          v-if="!teaching_text_name && $route.query.name != '预览'"
          style="display: none"
        >
          <div>教案</div>
          <div @click="torich_teaching()">新建</div>
          <div @click="add_teaching()">添加</div>
        </div>
        <!-- 已存在教案 -->
        <div class="had_content_toEdit" v-if="teaching_text_name" style="display: none">
          <div class="had_content_toEdit_title">
            教案 <span v-if="$route.query.name != '预览'">(点击可编辑)</span>
          </div>
          <div
            class="add_course_info_content_box_content_item"
            style="margin-bottom: 0"
            @click="torich_teaching()"
          >
            <div class="add_course_info_content_box_content_item_img">
              <div
                class="add_course_info_content_box_content_item_del"
                v-if="$route.query.name != '预览'"
                @click.stop="remove_teaching"
              >
                <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
              </div>
              <img
                src="../../assets/images/course_2.0/教案.png"
                class="add_course_info_content_box_content_item_img_teaching"
                alt=""
              />
            </div>
            <div class="add_course_info_content_box_content_item_txt">
              {{ teaching_text_name }}
            </div>
          </div>
        </div>
        <div
          class="add_course_info_head_course_name_add_teaching_guide"
          v-if="!course_content_guide_name && $route.query.name != '预览'"
          style="display: none"
        >
          <div>导学案</div>
          <div @click="torich_guidance()">新建</div>
          <div @click="add_guidance()">添加</div>
        </div>
        <!-- 已存在导学案  -->
        <div
          class="had_content_toEdit"
          v-if="course_content_guide_name"
          style="display: none"
        >
          <div class="had_content_toEdit_title">
            导学案 <span v-if="$route.query.name != '预览'">(点击可编辑)</span>
          </div>
          <div
            class="add_course_info_content_box_content_item"
            style="margin-bottom: 0"
            @click="
              $router.push(
                '/course/sign_course_edit_rich_guide?name=' + $route.query.name
              )
            "
          >
            <div class="add_course_info_content_box_content_item_img">
              <div
                class="add_course_info_content_box_content_item_del"
                v-if="$route.query.name != '预览'"
                @click.stop="remove_guide"
              >
                <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
              </div>
              <img
                src="../../assets/images/course_2.0/导学案.png"
                class="add_course_info_content_box_content_item_img_teaching"
                alt=""
              />
            </div>
            <div class="add_course_info_content_box_content_item_txt">
              {{ course_content_guide_name }}
            </div>
          </div>
        </div>
      </div>
      <!-- 新版 -->
      <div class="add_course_info_content">
        <!-- 教案 / 导学案-->
        <div class="add_file_box" v-for="i in 2" :key="i">
          <div class="file_box_head">
            <div>{{ i == 1 ? "教案" : "导学案" }}</div>
            <!-- <div
              @click="i == 1 ? torich_teaching() : torich_guidance()"
              v-if="
                (i == 1 ? !teaching_text_name : !course_content_guide_name) &&
                $route.query.name != '预览'
              "
            >
              <div class='creat_course'>
                {{ i == 1 ? "新建教案" : "新建导学案" }}
              </div>
            </div> -->
          </div>
          <div class="add_course_info_content_box_content">
            <div
              class="add_course_info_content_box_content_item"
              v-if="i == 1 ? !teaching_text_name : !course_content_guide_name"
            >
              <div
                class="add_course_info_content_box_content_item_img flex-row-center"
                v-if="$route.query.name != '预览'"
              >
                <div
                  class="newBtn flex-center"
                  @click="i == 1 ? add_teaching() : add_guidance()"
                >
                  挑选
                </div>
                <div
                  class="newBtn2 flex-center"
                  @click="i == 1 ? torich_teaching() : torich_guidance()"
                >
                  新建
                </div>
              </div>
              <!-- <div
                class="add_course_info_content_box_content_item_txt"
                v-if="$route.query.name != '预览'"
              >
                {{ i == 1 ? "挑选教案" : "挑选导学案" }}
              </div> -->
            </div>

            <div
              class="add_course_info_content_box_content_item"
              v-else
              @click="
                i == 1
                  ? torich_teaching()
                  : $router.push(
                      '/course/sign_course_edit_rich_guide?name=' + $route.query.name
                    )
              "
            >
              <div class="add_course_info_content_box_content_item_img">
                <div
                  class="add_course_info_content_box_content_item_del"
                  v-if="$route.query.name != '预览'"
                  @click.stop="i == 1 ? remove_teaching() : remove_guide()"
                >
                  <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
                </div>
                <img
                  v-if="i == 1"
                  src="../../assets/images/course_2.0/教案.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/images/course_2.0/导学案.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
              </div>
              <div class="add_course_info_content_box_content_item_txt">
                {{ i == 1 ? teaching_text_name : course_content_guide_name }}
              </div>
            </div>
          </div>
        </div>
        <!-- 课件 / 作业 /  试卷 / 视频 / 资料 -->
        <div
          class="add_file_box"
          v-for="(i_item, i_index) in ['课件', '作业', '视频', '资料']"
          :key="i_index + 11"
        >
          <div class="file_box_head">
            <div>{{ i_item }}</div>
            <!-- <div
              v-if="i_item != '作业' && $route.query.name != '预览'"
              @click="
                if (i_item == '课件') {
                  creat_data('1');
                } else if (i_item == '作业') {
                  creat_homework('2');
                } else if (i_item == '试卷') {
                  creat_data('3');
                } else if (i_item == '视频') {
                  creat_data('4');
                } else if (i_item == '资料') {
                  creat_data('5');
                }
              "
            >
              <div class='creat_course'>
                {{ "新建" + i_item }}
              </div>
            </div> -->
          </div>
          <div class="add_course_info_content_box_content">
            <div
              class="add_course_info_content_box_content_item"
              v-if="$route.query.name != '预览'"
            >
              <div
                class="add_course_info_content_box_content_item_img flex-row-center"
                v-if="i_item == '作业'"
                @click="add_material('2')"
              >
                <!-- <img
                  src="../../assets/images/course_2.0/添加.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                /> -->
                <div class='newBtn flex-center'>
                  挑选
                </div>
              </div>
              <div
                class="add_course_info_content_box_content_item_img flex-row-center"
                v-if="i_item != '作业'"
              >
                <div
                  class="newBtn flex-center"
                  @click="
                    if (i_item == '课件') {
                      add_material('1');
                    } else if (i_item == '作业') {
                      add_material('2');
                    } else if (i_item == '试卷') {
                      add_material('3');
                    } else if (i_item == '视频') {
                      add_material('4');
                    } else if (i_item == '资料') {
                      add_material('5');
                    }
                  "
                >
                  挑选
                </div>
                <div
                  class="newBtn2 flex-center"
                  @click="
                    if (i_item == '课件') {
                      creat_data('1');
                    } else if (i_item == '作业') {
                      creat_homework('2');
                    } else if (i_item == '试卷') {
                      creat_data('3');
                    } else if (i_item == '视频') {
                      creat_data('4');
                    } else if (i_item == '资料') {
                      creat_data('5');
                    }
                  "
                >
                  新建
                </div>
              </div>
              <!-- <div class="add_course_info_content_box_content_item_txt">
                {{ "挑选" + i_item }}
              </div> -->
            </div>
            <div
              class="add_course_info_content_box_content_item"
              @click="i_item == '作业' ? prew_homework(item) : prew_material(item)"
              v-for="(item, index) in i_item == '课件'
                ? content_json.courseware
                : i_item == '作业'
                ? content_json.homework
                : i_item == '试卷'
                ? content_json.exam
                : i_item == '视频'
                ? content_json.video
                : content_json.material"
              :key="index"
            >
              <div @click.stop="updateSend_to_type(item, i_item, index)" title="切换">
                <div class="send_to_type" v-if="item.send_to == 0">前</div>
                <div class="send_to_type" v-if="item.send_to == 1">中</div>
                <div class="send_to_type" v-if="item.send_to == 2">后</div>
              </div>

              <div class="add_course_info_content_box_content_item_img">
                <div
                  class="add_course_info_content_box_content_item_del"
                  v-if="$route.query.name != '预览'"
                  @click.stop="
                    $confirm('确认删除？')
                      .then((_) => {
                        del_config(i_item, index);
                      })
                      .catch((_) => {})
                  "
                >
                  <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
                </div>
                <img
                  v-if="
                    item.type == 'png' ||
                    item.type == 'jpg' ||
                    item.type == 'gif' ||
                    item.type == 'jpeg'
                  "
                  src="../../assets/images/course_2.0/图片.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-if="item.type == 'pdf' || item.type == 'PDF'"
                  src="../../assets/images/course_2.0/pdf.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item.type == 'ppt' ||
                    item.type == 'pptx' ||
                    item.type == 'PPT' ||
                    item.type == 'PPTX'
                  "
                  src="../../assets/images/course_2.0/PPT.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item.type == 'doc' ||
                    item.type == 'DOC' ||
                    item.type == 'docx' ||
                    item.type == 'DOCX'
                  "
                  src="../../assets/images/course_2.0/word.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="item.type == 'xls' || item.type == 'xlsx'"
                  src="../../assets/images/course_2.0/excel.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="item.type == 'mp3' || item.type == 'MP3'"
                  src="../../assets/images/course_2.0/音频.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
                <img
                  v-if="
                    item.type == 'mp4' ||
                    item.type == 'MP4' ||
                    item.type == 'wmv' ||
                    item.type == 'WMV' ||
                    item.type == 'mpg' ||
                    item.type == 'MPG' ||
                    item.type == 'avi' ||
                    item.type == 'AVI' ||
                    item.type == 'swf' ||
                    item.type == 'SWF' ||
                    item.type == 'flv' ||
                    item.type == 'FLV'
                  "
                  src="../../assets/images/course_2.0/视频.png"
                  class="add_course_info_content_box_content_item_img_homework"
                  alt=""
                />
                <img
                  v-if="i_item == '作业'"
                  src="../../assets/images/course_2.0/作业.png"
                  class="add_course_info_content_box_content_item_img_ppt"
                  alt=""
                />
              </div>
              <div class="add_course_info_content_box_content_item_txt">
                {{ item.name || item.title }}
              </div>
            </div>
            <!-- <div class="add_course_info_content_box_content_item_txt">{{i_item==1?teaching_text_name:course_content_guide_name}}</div> -->
          </div>
        </div>
      </div>
    </div>

    <!--  -->

    <div class="add_course_info_content" style="display: none">
      <!-- 课前-中-后  course_content_type渲染 -->
      <div
        class="add_course_info_content_box"
        v-for="(item_course_type, index_course_type) in 3"
        :key="index_course_type"
      >
        <div class="add_course_info_content_box_logo">
          <img
            src="../../assets/images/course_2.0/课前.png"
            alt=""
            v-if="index_course_type == 0"
          />
          <img
            src="../../assets/images/course_2.0/课中.png"
            alt=""
            v-if="index_course_type == 1"
          />
          <img
            src="../../assets/images/course_2.0/课后.png"
            alt=""
            v-if="index_course_type == 2"
          />
        </div>
        <div class="add_course_info_content_box_head">
          <div></div>
          <div class="add_course_info_content_box_head_operation">
            <div>
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_b"
                v-if="index_course_type == 0"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add"
                  v-if="$route.query.name != '预览'"
                >
                  新建
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="creat_homework">作业</div>
                  <div @click="creat_data">资料</div>
                </div>
              </el-popover>
              <!-- 课中新建 -->
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_m"
                v-if="index_course_type == 1"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add"
                  v-if="$route.query.name != '预览'"
                >
                  新建
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="creat_homework_m">作业</div>
                  <div @click="creat_data_m">资料</div>
                </div>
              </el-popover>
              <!-- 课后新建 -->
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_a"
                v-if="index_course_type == 2"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add"
                  v-if="$route.query.name != '预览'"
                >
                  新建
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="creat_homework_a">作业</div>
                  <div @click="creat_data_a">资料</div>
                </div>
              </el-popover>
            </div>

            <div>
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_add"
                v-if="index_course_type == 0"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add_add"
                  v-if="$route.query.name != '预览'"
                >
                  添加
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="add_homework(item_course_type, 0)">作业</div>
                  <div @click="add_material(item_course_type, 0)">资料</div>
                </div>
              </el-popover>
              <!-- 课中添加 -->
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_add_m"
                v-if="index_course_type == 1"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add_add"
                  v-if="$route.query.name != '预览'"
                >
                  添加
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="add_homework(item_course_type, 1)">作业</div>
                  <div @click="add_material(item_course_type, 1)">资料</div>
                </div>
              </el-popover>
              <!-- 课后添加 -->
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course_add"
                v-model="popover_sort_show_add_a"
                v-if="index_course_type == 2"
              >
                <div
                  slot="reference"
                  class="add_course_info_content_box_head_operation_add_add"
                  v-if="$route.query.name != '预览'"
                >
                  添加
                </div>
                <div class="add_course_info_content_box_head_operation_add_operation">
                  <div @click="add_homework(item_course_type, 2)">作业</div>
                  <div @click="add_material(item_course_type, 2)">资料</div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="add_course_info_content_box_content">
          <div
            class="add_course_info_content_box_content_item"
            @click="prew_homework(item)"
            v-for="(item, index) in index_course_type == 0
              ? course_content_type.b.uuid
              : index_course_type == 1
              ? course_content_type.m.uuid
              : course_content_type.a.uuid"
            :key="index"
          >
            <div class="add_course_info_content_box_content_item_img">
              <div
                class="add_course_info_content_box_content_item_del"
                v-if="$route.query.name != '预览'"
                @click.stop="
                  $confirm('确认删除？')
                    .then((_) => {
                      if (index_course_type == 0) {
                        course_content_type.b.uuid.splice(index, 1);
                      } else if (index_course_type == 1) {
                        course_content_type.m.uuid.splice(index, 1);
                      } else {
                        course_content_type.a.uuid.splice(index, 1);
                      }
                    })
                    .catch((_) => {})
                "
              >
                <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
              </div>
              <img
                src="../../assets/images/course_2.0/作业.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
            </div>
            <div class="add_course_info_content_box_content_item_txt">
              {{ item.name || item.title }}
            </div>
          </div>
          <div
            class="add_course_info_content_box_content_item"
            @click="prew_material(item_f)"
            v-for="(item_f, index_f) in index_course_type == 0
              ? course_content_type.b.f
              : index_course_type == 1
              ? course_content_type.m.f
              : course_content_type.a.f"
            :key="index_f + 'f'"
          >
            <div class="add_course_info_content_box_content_item_img">
              <div
                class="add_course_info_content_box_content_item_del"
                v-if="$route.query.name != '预览'"
                @click.stop="
                  $confirm('确认删除？')
                    .then((_) => {
                      if (index_course_type == 0) {
                        course_content_type.b.f.splice(index_f, 1);
                      } else if (index_course_type == 1) {
                        course_content_type.m.f.splice(index_f, 1);
                      } else {
                        course_content_type.a.f.splice(index_f, 1);
                      }
                    })
                    .catch((_) => {})
                "
              >
                <img src="../../assets/images/course_2.0/del_course_item.png" alt="" />
              </div>
              <img
                v-if="
                  item_f.type == 'png' ||
                  item_f.type == 'jpg' ||
                  item_f.type == 'gif' ||
                  item_f.type == 'jpeg'
                "
                src="../../assets/images/course_2.0/图片.png"
                class="add_course_info_content_box_content_item_img_homework"
                alt=""
              />
              <img
                v-if="item_f.type == 'pdf' || item_f.type == 'PDF'"
                src="../../assets/images/course_2.0/pdf.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
              <img
                v-if="
                  item_f.type == 'ppt' ||
                  item_f.type == 'pptx' ||
                  item_f.type == 'PPT' ||
                  item_f.type == 'PPTX'
                "
                src="../../assets/images/course_2.0/PPT.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
              <img
                v-if="
                  item_f.type == 'doc' ||
                  item_f.type == 'DOC' ||
                  item_f.type == 'docx' ||
                  item_f.type == 'DOCX'
                "
                src="../../assets/images/course_2.0/word.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
              <img
                v-if="item_f.type == 'xls' || item_f.type == 'xlsx'"
                src="../../assets/images/course_2.0/excel.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
              <img
                v-if="item_f.type == 'mp3' || item_f.type == 'MP3'"
                src="../../assets/images/course_2.0/音频.png"
                class="add_course_info_content_box_content_item_img_ppt"
                alt=""
              />
              <img
                v-if="
                  item_f.type == 'mp4' ||
                  item_f.type == 'MP4' ||
                  item_f.type == 'wmv' ||
                  item_f.type == 'WMV' ||
                  item_f.type == 'mpg' ||
                  item_f.type == 'MPG' ||
                  item_f.type == 'avi' ||
                  item_f.type == 'AVI' ||
                  item_f.type == 'swf' ||
                  item_f.type == 'SWF' ||
                  item_f.type == 'flv' ||
                  item_f.type == 'FLV'
                "
                src="../../assets/images/course_2.0/视频.png"
                class="add_course_info_content_box_content_item_img_homework"
                alt=""
              />
            </div>
            <div
              class="add_course_info_content_box_content_item_txt"
              :title="item_f.name || item_f.title"
            >
              {{ item_f.name || item_f.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var projects = [{ title: "第四单元", time: "2019-06-10", num: "0", user: "新纪元老师" }];
import bus from "../../plugins/Bus";
import previewData from "../../components/common_module/preview_data.vue";
import { getNodeCode_topic, getNodeCode } from "../../assets/js/common";
import urlList from "../../utils/serverUrlList";
export default {
  components: { previewData },
  data() {
    return {
      status: "3",
      innerVisible_update: false,
      status_to_examine: false,
      status_value: false,
      SectionData: [],
      chapter_popover: false,
      chapter_name: "请选择章节",
      SectionProps: {
        children: "children",
        label: "name",
      },
      showNode: [],
      innerVisible_add_homework: false,
      innerVisible_add: false,
      innerVisible: false,
      content_json: {
        courseware: [],
        homework: [],
        exam: [],
        video: [],
        material: [],
      },
      // 2.0
      ispercentage: 0,
      edit_material_item_type: "add",
      add_material_name: "新建资料",
      dialogVisible_add_material: false,
      add_material_list: [],
      options_add_material: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: true,
        attrs: {
          accept: "*",
        },

        chunkSize: "1024000",
      },
      show_progress: false,
      prew_content: "",
      prew_type: "",
      dialogVisible_previewData: false,
      course_content_guide_json: "",
      course_content_guide_name: "",
      is_typeof_add_to: "1",
      myselef_check: false,
      popover_sort_show_b: false,
      popover_sort_show_m: false,
      popover_sort_show_a: false,
      popover_sort_show_add: false,
      popover_sort_show_add_m: false,
      popover_sort_show_add_a: false,
      course_content_type: {
        b: { uuid: [], f: [], exam: [] },
        m: { uuid: [], f: [], exam: [] },
        a: { uuid: [], f: [], exam: [] },
      },
      list_for_choose: [],
      arr_choosed_card: [],
      total: 0,
      pageNum: 1,
      popover_sort_show: false,
      starttime_sort: "",
      end_time_sort: "",
      order: "",
      sort: "",
      material_label_id: "",
      homework_label_id: "",
      sort_time: "全部",
      sort_type: "时间最新",
      search_data: "",
      tab_active: 3,
      tap_list: ["云", "学校", "共享", "我的"],
      add_homework_material_dia: false,
      new_add_type: "",
      chapter_code: "",
      //

      dialogVisible_g: false,
      dialogVisible_t: false,

      previewVideoUrl: "",
      srcList_img: "",
      data_dataList: [],
      dialogVisible: false,
      Isactive: true,
      s_name: "公有",
      s_code: 1,
      list_switch: [
        { name: "公有", active: true },
        { name: "私有", active: false },
      ],
      status_course: false,
      course_name_text: "",
      course_name: "",
      type: "",
      list_mount_exam: [],
      list_after_exam: [],
      list_before_exam: [],
      list_before_uuid: [],
      list_before_f: [],
      list_mount_uuid: [],
      list_mount_f: [],
      list_after_uuid: [],
      list_after_f: [],
      course_content: {}, //备课包内容
      guidance_text: "", //导学
      teaching_text: "", //教学
      teaching_text_name: "", //教学
      saved: false,
      id: "",
      datalist: [],
      Isshow: true,
      widow_title: "",
      visible: false,
      list: projects,
      srcList: [],
      form: {},
      rules: {},
      current_label: "",
      options_label: [],
      checkItem: "",
      teaching_uuid: "",
      guidance_uuid: "",
      from_name: this.$route.query.from,
    };
    props: {
      del: {
        type: String;
      }
      Isthickness: {
        type: Boolean;
      }
    }
  },
  beforeCreate() {},
  created() {
    this.options_add_material.target =
      JSON.parse(sessionStorage.userInfo).school.server_url + "/school/common/zoneupload";
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    //获取章节编码
    try {
      this.chapter_code = JSON.parse(sessionStorage.course_new_obj).chapter_code;
      this.course_name = JSON.parse(sessionStorage.course_new_obj).chapter_name;
    } catch (error) {}
    //获取标签
    //从 资料袋跳转过来
    if (this.$route.query.from == "myResource") {
      this.status_value = true;
    }
    if (this.$route.query.from == "index") {
      this.getSubject(sessionStorage.getItem("subject_code"));
      let cartIds = sessionStorage.getItem("cartIds");
      let params = {
        cart_ids: cartIds,
      };
      this.teaching_text = sessionStorage.teaching_text
        ? sessionStorage.teaching_text
        : "";
      this.teaching_text_name = sessionStorage.teaching_text_name || "";
      this.teaching_uuid = sessionStorage.teaching_uuid || "";
      this.course_content_guide_name = sessionStorage.course_content_guide_name || "";
      this.course_content_guide_json = sessionStorage.course_content_guide_json || [];
      this.axios.post("/school/cart/courseCartDetail", params).then((res) => {
        if (res.data.code == 1) {
          for (let i in res.data.data.data) {
            if (res.data.data.data[i].type == 2) {
              this.teaching_text_name = res.data.data.data[i].name;
              this.teaching_text = res.data.data.data[i].content;
              this.teaching_uuid = res.data.data.data[i].uuid;
            }
            if (res.data.data.data[i].type == 3) {
              this.course_content_guide_name = res.data.data.data[i].name;
              this.guidance_uuid = res.data.data.data[i].uuid;
              this.course_content_guide_json = JSON.parse(res.data.data.data[i].content);
              // sessionStorage.course_content_guide_name =
              //   res.data.data.data[i].name;
              // sessionStorage.course_content_guide_json = JSON.stringify(
              //   this.course_content_guide_json
              // );
            }
            if (res.data.data.data[i].type == 4) {
              let obj = {
                homework_uuid: res.data.data.data[i].content.homework_uuid,
                send_to: "1",
                title: res.data.data.data[i].content.name,
              };
              this.content_json["homework"].push(obj);
            }
            if (
              res.data.data.data[i].type == 5 ||
              res.data.data.data[i].type == 8 ||
              res.data.data.data[i].type == 7
            ) {
              let obj = JSON.parse(res.data.data.data[i].content)[0];
              obj.send_to = "1";
              obj.material_uuid = res.data.data.data[i].uuid;
              this.content_json["material"].push(obj);
            }
            if (res.data.data.data[i].type == 6) {
              let obj = JSON.parse(res.data.data.data[i].content)[0];
              obj.send_to = "1";
              obj.material_uuid = res.data.data.data[i].uuid;
              this.content_json["courseware"].push(obj);
            }
            if (res.data.data.data[i].type == 9) {
              let obj = JSON.parse(res.data.data.data[i].content)[0];
              obj.send_to = "1";
              obj.material_uuid = res.data.data.data[i].uuid;
              this.content_json["video"].push(obj);
            }
          }
        }
      });
    }
    this.course_name_text = this.$route.query.name;

    if (sessionStorage.course_add_type == "new" && this.$route.query.from != "index") {
      try {
        this.content_json = JSON.parse(sessionStorage.content_json);
      } catch (error) {
        this.content_json = {
          courseware: [],
          homework: [],
          exam: [],
          video: [],
          material: [],
        };
      }
      this.course_content = sessionStorage.course_content
        ? JSON.parse(sessionStorage.course_content)
        : {
            i: "重点",
            d: "难点",
            e: "考点",
            b: { uuid: [], f: [], exam: [] },
            m: { uuid: [], f: [], exam: [] },
            a: { uuid: [], f: [], exam: [] },
          };
      this.list_after_uuid = this.course_content.a.uuid;
      this.list_after_exam = this.course_content.a.exam;
      this.list_after_f = this.course_content.a.f;
      this.list_mount_exam = this.course_content.m.exam;
      this.list_mount_uuid = this.course_content.m.uuid;
      this.list_mount_f = this.course_content.m.f;
      this.list_before_exam = this.course_content.b.exam;
      this.list_before_uuid = this.course_content.b.uuid;
      this.list_before_f = this.course_content.b.f;

      // alert(1)
      this.add_byheat = false;
      this.course_name = sessionStorage.course_new_obj
        ? JSON.parse(sessionStorage.course_new_obj).courseName
        : "";
      this.teaching_text = sessionStorage.teaching_text
        ? sessionStorage.teaching_text
        : "";
      this.teaching_text_name = sessionStorage.teaching_text_name || "";
      this.teaching_uuid = sessionStorage.teaching_uuid || "";
      this.guidance_uuid = sessionStorage.guidance_uuid || "";
      this.guidance_text = sessionStorage.guidance_text
        ? sessionStorage.guidance_text
        : "";

      this.course_content_guide_name = sessionStorage.course_content_guide_name || "";
      this.course_content_guide_json = sessionStorage.course_content_guide_json || [];
      this.course_name =
        sessionStorage.course_content_course_name ||
        (sessionStorage.course_new_obj
          ? JSON.parse(sessionStorage.course_new_obj).chapter_name
          : "新建备课包");
    } else {
      //编辑
      if (this.$route.query.from != "index") {
        this.id = sessionStorage.course_new_courseId;
        let formData_detail = new FormData();
        formData_detail.append("uuid", sessionStorage.course_new_courseId);
        let server_url = sessionStorage.getItem("server_url");
        let url =
          this.$route.query.from == "videotapeCompetition" ||
          this.$route.query.from == "shuobokeCompetition"
            ? `${server_url}/school/course/courseDetail`
            : // : "/teacher/course/courseDetail";
            this.$route.query.isSchool == 3
            ? "/teacher/course/courseDetail"
            : "/school/course/courseDetail"; //0云端 1学校 2共享 3 我的 除0外都走学校

        if (this.$route.query.school_code) {
          urlList.forEach((item) => {
            console.log(item.school_code, this.$route.query.school_code);
            if (item.school_code == this.$route.query.school_code) {
              url = `${item.url}/school/course/courseDetail`;
            }
          });
        }

        this.axios.post(url, formData_detail).then((res) => {
          if (res.data.data.data.status !== 1) {
            this.status_course = false;
          } else {
            this.status_course = true;
          }
          let course_content_type = JSON.parse(res.data.data.data.content);
          if (res.data.code == 1) {
            let content_json = {
              courseware: [],
              homework: [],
              exam: [],
              video: [],
              material: [],
            };
            for (let i in course_content_type.a.f) {
              if (course_content_type.a.f[i].type_from) {
                content_json[course_content_type.a.f[i].type_from].push(
                  course_content_type.a.f[i]
                );
              } else {
                content_json["material"].push(course_content_type.a.f[i]);
              }
            }
            for (let i in course_content_type.a.uuid) {
              content_json["homework"].push(course_content_type.a.uuid[i]);
            }

            for (let i in course_content_type.m.f) {
              if (course_content_type.m.f[i].type_from) {
                content_json[course_content_type.m.f[i].type_from].push(
                  course_content_type.m.f[i]
                );
              } else {
                content_json["material"].push(course_content_type.m.f[i]);
              }
            }
            for (let i in course_content_type.m.uuid) {
              content_json["homework"].push(course_content_type.m.uuid[i]);
            }

            for (let i in course_content_type.b.f) {
              if (course_content_type.b.f[i].type_from) {
                content_json[course_content_type.b.f[i].type_from].push(
                  course_content_type.b.f[i]
                );
              } else {
                content_json["material"].push(course_content_type.b.f[i]);
              }
            }
            for (let i in course_content_type.b.uuid) {
              content_json["homework"].push(course_content_type.b.uuid[i]);
            }
            this.content_json = content_json;

            //

            this.course_content_type = sessionStorage.course_content_type
              ? JSON.parse(sessionStorage.course_content_type)
              : course_content_type;
            res.data.data.data.heat > 0
              ? (this.add_byheat = false)
              : (this.add_byheat = true);
            // alert(this.add_byheat)
            this.list_after_uuid = this.course_content_type.a.uuid;
            this.list_after_exam = this.course_content_type.a.exam;
            this.list_after_f = this.course_content_type.a.f;
            this.list_mount_exam = this.course_content_type.m.exam;
            this.list_mount_uuid = this.course_content_type.m.uuid;
            this.list_mount_f = this.course_content_type.m.f;
            this.list_before_exam = this.course_content_type.b.exam;
            this.list_before_uuid = this.course_content_type.b.uuid;
            this.list_before_f = this.course_content_type.b.f;
            this.chapter_code = res.data.data.data.chapter_code;
            this.course_name = res.data.data.data.name;
            this.course_id = res.data.data.data.id;

            if (
              res.data.data.data.approval_status == 20 ||
              res.data.data.data.approval_status == 40
            ) {
              this.status_value = true;
            }

            if (sessionStorage.teaching_text_e) {
              this.teaching_text = sessionStorage.teaching_text_e;
              this.teaching_text_name = sessionStorage.teaching_text_name_e || "";
            } else {
              if (sessionStorage.teaching_text_e == "") {
                this.teaching_text = "";
                this.teaching_text_name = sessionStorage.teaching_text_name || "";
              } else {
                console.log(res.data.data.data);
                this.teaching_text = res.data.data.data.teaching;
                this.teaching_text_name = res.data.data.data.teaching_name;
                this.teaching_uuid = res.data.data.data.teaching_uuid;
              }
            }

            if (sessionStorage.guidance_text_e) {
              this.guidance_text = sessionStorage.guidance_text_e;
            } else {
              if (sessionStorage.guidance_text_e == "") {
                this.guidance_text = "";
              } else {
                this.guidance_text = res.data.data.data.guidance;
                this.guidance_uuid = res.data.data.data.guidance_uuid;
              }
            }
            if (sessionStorage.course_content_guide_json) {
              try {
                this.course_content_guide_json = JSON.parse(
                  sessionStorage.course_content_guide_json
                );
              } catch (error) {
                this.course_content_guide_json = sessionStorage.course_content_guide_json;
              }
            } else {
              try {
                this.course_content_guide_json = JSON.parse(res.data.data.data.guidance);
              } catch (error) {
                this.course_content_guide_json = res.data.data.data.guidance;
              }

              sessionStorage.course_content_guide_json =
                JSON.stringify(this.course_content_guide_json) || "";
            }
            if (sessionStorage.course_content_guide_name) {
              this.course_content_guide_name = sessionStorage.course_content_guide_name;
            } else {
              this.course_content_guide_name = course_content_type.guidance_name;
              sessionStorage.course_content_guide_name =
                this.course_content_guide_name || "";
            }
            if (sessionStorage.teaching_text) {
              this.teaching_text = sessionStorage.teaching_text;
            } else {
              this.teaching_text = res.data.data.data.teaching;
              sessionStorage.teaching_text = this.teaching_text || "";
            }

            if (sessionStorage.teaching_text_name) {
              this.teaching_text_name = sessionStorage.teaching_text_name || "";
            } else {
              // alert(1)
              // console.log(course_content_type)

              this.teaching_text_name = course_content_type.teaching_name;
              sessionStorage.teaching_text_name = this.teaching_text_name || "";
            }

            // this.course_content_guide_name=course_content_type.guidance_name||''
            // this.course_content_guide_json=JSON.parse(res.data.data.data.guidance)||[]
            // this.teaching_text_name=course_content_type.teaching_name||''
            // this.teaching_text=res.data.data.data.teaching||""

            // sessionStorage.course_content_guide_json=this.course_content_guide_json
            // sessionStorage.course_content_guide_name=this.course_content_guide_name
            // sessionStorage.teaching_text_name=this.teaching_text_name
            // sessionStorage.teaching_text=this.teaching_text
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
      }
    }
  },
  filters: {
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input * 1000);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
  },
  methods: {
    goBack() {
      if (this.$route.query.from == "resource") {
        this.$router.push("/resource");
      } else if (this.$route.query.from == "resource_send") {
        this.$router.push("/resource_send");
      } else if (this.$route.query.from == "myResource") {
        this.$router.push("/myResource");
      } else if (this.$route.query.from == "research") {
        this.$router.push({
          name: "/research_class_detail",
          params: {
            type: 2,
            uuid: this.$route.query.research_uuid,
          },
        });
      } else if (this.$route.query.from == "videotapeCompetition") {
        this.$router.go(-1);
      } else if (this.$route.query.from == "research_detail") {
        this.$router.go(-1);
      } else if (this.$route.query.from == "attend_class") {
        this.$router.go(-1);
      } else if (this.$route.query.from == "shuobokeCompetition") {
        this.$router.push("/shuobokeCompetition");
      } else {
        this.$router.push("/resource");
      }
    },
    updateSend_to_type(item) {
      this.is_typeof_add_to = item.send_to;
      this.checkItem = item;
      this.innerVisible_update = true;
    },
    onInnerVisible_update() {
      this.checkItem.send_to = this.is_typeof_add_to;
      this.innerVisible_update = false;
    },
    getSectionData(data) {
      let str = getNodeCode_topic(data, []).join(",");
      this.str_node = str;
      let str_hax_all = getNodeCode(data, []);
      this.str_hax_all = str_hax_all;
      //  console.log(data)
      this.chapter_code = data.c;
      console.log(data);
      this.chapter_popover = false;
      this.chapter_name = data.name;
    },
    //获取教材 章节
    getSubject(code) {
      let formData = new FormData();
      formData.append("subject_code", code);
      this.axios.post("/teacher/subject/gettextbook", formData).then((res) => {
        if (res.data.code == 1) {
          let arr = res.data.data;
          for (let i in arr) {
            if (arr[i].id == JSON.parse(sessionStorage.userInfo).textbook_code) {
              this.SectionData = JSON.parse(arr[i].chapter_json);
              for (let j in this.SectionData) {
                this.showNode.push(this.SectionData[j].guid);
              }
            }
          }
          if (!JSON.parse(sessionStorage.userInfo).textbook_code) {
            this.SectionData = JSON.parse(arr[0].chapter_json);
            for (let j in this.SectionData) {
              this.showNode.push(this.SectionData[j].guid);
            }
          }
        }
      });
    },

    //
    del_config(i_item, index) {
      if (i_item == "课件") {
        this.content_json["courseware"].splice(index, 1);
      } else if (i_item == "作业") {
        this.content_json["homework"].splice(index, 1);
      } else if (i_item == "试卷") {
        this.content_json["exam"].splice(index, 1);
      } else if (i_item == "视频") {
        this.content_json["video"].splice(index, 1);
      } else if (i_item == "资料") {
        this.content_json["material"].splice(index, 1);
      }
      console.log(i_item);
      console.log(index);
    },

    //生成资料
    save_add_material() {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let url = "/school/Material/addMaterial";
      var formData = new FormData();
      formData.append("school_code", userInfo.school_code);
      formData.append("subject_code", userInfo.subject_code);
      if (this.edit_material_item_type == "edit") {
        formData.append("chapter_code", this.edit_material_item.chapter_code);
      } else {
        formData.append("chapter_code", this.chapter_code);
      }
      formData.append("textbook_guid", sessionStorage.text_book_guid);

      formData.append("material_label_id", "");
      formData.append("name", this.add_material_name);
      formData.append("sub_num", this.add_material_list.length);
      formData.append("file", JSON.stringify(this.add_material_list));
      formData.append("teacher_name", JSON.parse(sessionStorage.userInfo).name);
      // formData.append("file_src",file_src );
      formData.append("file_type", ""); //1变空

      formData.append("status", this.status_course == false ? 2 : 1);

      formData.append("from", userInfo.school.name);
      formData.append("remark", "");
      this.axios.post(url, formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });

          // return
          //let obj = JSON.parse(res.data.data.data.url)[0];
          for (let i in JSON.parse(res.data.data.data.url)) {
            let obj = JSON.parse(res.data.data.data.url)[i];
            obj.send_to = this.is_typeof_add_to;

            this.content_json[this.add_to_json].push(obj);
          }
          // let arr_homework=this.course_content_type

          //     // console.log(arr_homework.b)
          //     if(this.edit_material_item_type_type=='b'){
          //         arr_homework.b.f.push(obj)
          //     }else if(this.edit_material_item_type_type=='m'){
          //           arr_homework.m.f.push(obj)
          //     }else if(this.edit_material_item_type_type=='a'){
          //           arr_homework.a.f.push(obj)
          //     }
          //      this.course_content_type=arr_homework

          this.dialogVisible_add_material = false;

          // if(this.edit_material_item_type=='edit'){
          //     if(this.edit_material_item.heat>0){

          //     }else{
          //         this.uncollect(this.edit_material_item.material_uuid)
          //     }
          // }

          //     this.dialogVisible_add_material=false

          //     this.get_sourceBag()
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    // 上传回调
    onFileProgress(rootFile, file, chunk) {
      if (Math.floor((chunk.endByte / file.size) * 100) > this.ispercentage) {
        this.ispercentage = Math.floor((chunk.endByte / file.size) * 100);
        //  console.log(this.ispercentage)
      }
    },
    onFileAdded(file) {
      // console.log(file)
      this.ispercentage = 0;
      if (
        (file.fileType.indexOf("presentation") != -1 ||
          file.fileType.indexOf("powerpoint") != -1) &&
        file.size / 1024 / 1024 >= 100
      ) {
        file.pause();
        this.$message({
          duration: 3000,
          type: "error",
          message: "ppt大小不能超过100M!",
        });
      }
      if (this.type_second == "material_2") {
        let arr_file_name = file.name.split(".");
        let type_file = arr_file_name[arr_file_name.length - 1];

        if (
          type_file.indexOf("pptx") == -1 &&
          type_file.indexOf("doc") == -1 &&
          type_file.indexOf("DOC") == -1 &&
          type_file.indexOf("docx") == -1 &&
          type_file.indexOf("DOCX") == -1 &&
          type_file.indexOf("xls") == -1 &&
          type_file.indexOf("xlsx") == -1 &&
          type_file.indexOf("pdf") == -1
        ) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "文件类型仅限（pdf、pptx、word、excel）!",
          });
          return;
        }
      } else if (this.type_second == "material_3") {
        if (
          file.fileType.indexOf("gif") == -1 &&
          file.fileType.indexOf("jpeg") == -1 &&
          file.fileType.indexOf("jpg") == -1 &&
          file.fileType.indexOf("png") == -1
        ) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "文件类型仅限（jpg、png）!",
          });
          return;
        }
      } else if (this.type_second == "material_4") {
        if (file.fileType.indexOf("audio/mpeg") == -1) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "文件类型仅限（mp3）!",
          });
          return;
        }
      } else if (this.type_second == "material_5") {
        if (file.fileType.indexOf("mp4") == -1) {
          file.pause();
          this.$message({
            duration: 3000,
            type: "error",
            message: "文件类型仅限（mp4）!",
          });
          return;
        }
        // console.log(5);
      }
      this.show_progress = true;
    },
    onFileSuccess(rootFile, file, response, chunk) {
      this.ispercentage = 100;
      //this.show_progress = false;

      if (JSON.parse(response).code == 1) {
        // console.log(file)

        // console.log(response)

        try {
          this.upFile_src = JSON.parse(response).data;
        } catch (error) {
          this.upFile_src = response;
        }
        this.upFile_type = file.name.split(".")[file.name.split(".").length - 1];
        this.ispercentage = 0;
        this.add_material_list.push({
          name: file.name,
          url: this.upFile_src,
          type: file.name.split(".")[file.name.split(".").length - 1],
          id: file.id,
        });
        this.show_progress = false;
      } else {
        // file-removed(file)
        this.$message({
          type: "error",
          message: JSON.parse(response).msg,
          duration: 1500,
          showClose: true,
        });
      }

      // console.log(chunk)
      // this.$router.push({ path: "/sign_data" });
    },
    //新建资料
    add_material_up(type) {
      if (type == 1) {
        this.add_to_json = "courseware";
      } else if (type == 4) {
        this.add_to_json = "video";
      } else if (type == 5) {
        this.add_to_json = "material";
      }
      this.innerVisible_add = true;
      // this.edit_material_item_type_type=type
      //  this.dialogVisible_add_material=true
      this.add_material_list = [];
      this.add_material_name = "新建资料";
      this.edit_material_item_type = "add";
    },
    //2.0
    //预览作业资料
    prew_homework(item) {
      this.prew_type = "homework";
      this.prew_content = item;
      this.dialogVisible_previewData = true;
    },
    prew_material(item) {
      console.log(item);
      // return
      if (
        item.type == "mp4" ||
        item.type == "MP4" ||
        item.type == "avi" ||
        item.type == "AVI" ||
        item.type == "flv" ||
        item.type == "FLV" ||
        item.type == "SWF" ||
        item.type == "swf" ||
        item.type == "mpg" ||
        item.type == "MPG" ||
        item.type == "wmv" ||
        item.type == "WMV"
      ) {
        this.prew_type = "mp4";
      } else if (
        item.type == "png" ||
        item.type == "PNG" ||
        item.type == "jpg" ||
        item.type == "JPG" ||
        item.type == "jpeg" ||
        item.type == "JPEG"
      ) {
        this.prew_type = "img";
      } else if (
        item.type == "doc" ||
        item.type == "DOC" ||
        item.type == "docx" ||
        item.type == "DOCX" ||
        item.type == "ppt" ||
        item.type == "PPT" ||
        item.type == "pptx" ||
        item.type == "PPTX" ||
        item.type == "xls" ||
        item.type == "xlsx"
      ) {
        this.prew_type = "ppt";
      } else if (item.type == "mp3" || item.type == "MP3") {
        this.prew_type = "mp3";
      } else if (item.type == "pdf" || item.type == "PDF") {
        this.prew_type = "pdf";
      }

      this.prew_content = item;
      console.log(item);
      this.dialogVisible_previewData = true;
    },

    remove_guide(item) {
      this.$confirm("确认删除？")
        .then((_) => {
          this.course_content_guide_name = "";
          this.course_content_guide_json = "";
          sessionStorage.course_content_guide_name = "";
          sessionStorage.course_content_guide_json = "";
        })
        .catch((_) => {});
    },
    remove_teaching() {
      this.$confirm("确认删除？")
        .then((_) => {
          this.teaching_text = "";
          this.teaching_text_name = "";
          sessionStorage.teaching_text = "";
          sessionStorage.teaching_text_name = "";
        })
        .catch((_) => {});
    },
    creat_homework() {
      this.popover_sort_show_b = false;
      this.innerVisible_add_homework = true;
      //  this.$router.push('/course/creat_homework?is_course_type='+this.is_typeof_add_to)
    },
    creat_data(type) {
      this.popover_sort_show = false;
      this.add_material_up(type);
    },
    creat_homework_m() {
      this.popover_sort_show_m = false;
      this.$router.push("/course/creat_homework?is_course_type=m");
    },
    creat_data_m() {
      this.popover_sort_show_m = false;
      this.add_material_up("m");
    },
    creat_homework_a() {
      this.popover_sort_show_a = false;
      this.$router.push("/course/creat_homework?is_course_type=a");
    },
    creat_data_a() {
      this.popover_sort_show_a = false;
      this.add_material_up("a");
    },
    add_material(item, index) {
      if (item == "1") {
        this.file_type = 2;
      } else if (item == "4") {
        this.file_type = 5;
      } else {
        this.file_type = ""; //1变空
      }
      this.pageNum = 1;
      this.tab_active = 3;

      // this.can_add=false

      if (item == "1") {
        this.new_add_type = "courseware";
      } else if (item == "2") {
        this.new_add_type = "homework";
      } else if (item == "3") {
        this.new_add_type = "exam";
      } else if (item == "4") {
        this.new_add_type = "video";
      } else if (item == "5") {
        this.new_add_type = "material";
      }

      this.innerVisible = true;
      // this.add_homework_material_dia=true
      this.arr_choosed_card = [];
      this.choose_tab_active(3);
      // this.is_typeof_add_to=index
    },
    add_teaching() {
      this.pageNum = 1;
      this.tab_active = 3;
      this.new_add_type = "teaching";
      this.arr_choosed_card = [];
      this.add_homework_material_dia = true;
      this.choose_tab_active(3);
    },
    add_guidance() {
      this.pageNum = 1;
      this.tab_active = 3;
      this.new_add_type = "guidance";
      this.arr_choosed_card_guidance = [];
      this.add_homework_material_dia = true;
      this.choose_tab_active(3);
    },
    add_homework(item, index) {
      //index 是课前课中课后
      this.pageNum = 1;
      this.tab_active = 3;
      // this.can_add=false
      this.new_add_type = "homework";
      this.add_homework_material_dia = true;
      this.arr_choosed_card = [];
      this.choose_tab_active(3);
      // this.is_typeof_add_to=index
    },
    //选择 类型 云 学校 我的 共享
    choose_tab_active(index) {
      this.tab_active = index;
      if (this.new_add_type == "homework") {
        if (this.tab_active == 0) {
          //云作业
          this.get_work_list(this.order, this.sort);
        } else if (this.tab_active == 1) {
          //学校作业
          this.get_school_job_list(this.order, this.sort);
        } else if (this.tab_active == 2) {
          //共享作业
          this.get_new_job_list(this.order, this.sort);
        } else if (this.tab_active == 3) {
          //我的作业
          this.get_my_job_list(this.order, this.sort);
        }
      } else if (
        this.new_add_type == "material" ||
        this.new_add_type == "courseware" ||
        this.new_add_type == "video"
      ) {
        if (this.tab_active == 3) {
          this.get_my_data_list(this.order, this.sort);
        } else if (this.tab_active == 0) {
          this.getQuestion(this.order, this.sort);
        } else if (this.tab_active == 2) {
          this.get_new_data_list(this.order, this.sort);
        } else if (this.tab_active == 1) {
          this.get_school_data_list(this.order, this.sort);
        }
      } else if (this.new_add_type == "teaching") {
        // 获取教案
        if (this.tab_active == 0) {
          this.get_teacher_course_list(this.order, this.sort);
        } else if (this.tab_active == 1) {
          this.right_status = 3;
          this.get_school_course(this.order, this.sort);
        } else if (this.tab_active == 2) {
          this.right_status = 2;
          this.get_school_course(this.order, this.sort);
        } else if (this.tab_active == 3) {
          this.get_collection_list(this.order, this.sort);
        }
      } else {
        // 获取导学案
        if (this.tab_active == 0) {
          this.get_teacher_guidance_list(this.order, this.sort);
        } else if (this.tab_active == 1) {
          this.right_status = 3;
          this.get_school_guidance(this.order, this.sort);
        } else if (this.tab_active == 2) {
          this.right_status = 2;
          this.get_school_guidance(this.order, this.sort);
        } else if (this.tab_active == 3) {
          this.get_collection_list_guidance(this.order, this.sort);
        }
      }
    },
    change_sort_time(type) {
      this.popover_sort_show = false;
      this.sort_time = type;
      this.sort_getdata();
    },
    change_sort_type(type) {
      this.popover_sort_show = false;
      this.sort_type = type;
      this.sort_getdata();
    },
    sort_getdata() {
      let timestamp = Date.parse(new Date());
      if (this.sort_time == "全部") {
        this.starttime_sort = "";
        this.end_time_sort = "";
      } else if (this.sort_time == "最近一周") {
        this.starttime_sort = timestamp - 1000 * 7 * 24 * 60 * 60;
        this.end_time_sort = timestamp;
      } else if (this.sort_time == "最近一月") {
        this.starttime_sort = timestamp - 1000 * 30 * 24 * 60 * 60;
        this.end_time_sort = timestamp;
      } else if (this.sort_time == "最近一年") {
        this.starttime_sort = timestamp - 1000 * 365 * 24 * 60 * 60;
        this.end_time_sort = timestamp;
      }
      if (this.sort_type == "时间最新") {
        this.order = "descending";
        this.sort = "createtime";
      } else if (this.sort_type == "时间最早") {
        this.order = "ascending";
        this.sort = "createtime";
      } else if (this.sort_type == "热度最高") {
        this.order = "descending";
        this.sort = "heat";
      }
      this.pageNum = 1;
      this.choose_tab_active(this.tab_active);
    },
    //分页 换页
    changePage(pageNum) {
      this.pageNum = pageNum;

      this.choose_tab_active(this.tab_active);
    },
    //选择作业资料加入数组
    choose_card(item) {
      if (this.new_add_type == "teaching") {
        //  console.log(this.arr_choosed_card)
        this.arr_choosed_card = [];
        this.arr_choosed_card.push(item);
      } else if (this.new_add_type == "guidance") {
        this.arr_choosed_card = [];
        this.arr_choosed_card.push(item);
      } else {
        if (!this.card_in_arr(item)) {
          if (this.new_add_type != "homework") {
            this.arr_choosed_card.push(item);
          } else {
            let obj = {};
            obj.title = item.title;
            obj.homework_uuid = item.homework_uuid || item.uuid;
            obj.id = item.id || item.homework_id;
            console.log(obj);
            this.arr_choosed_card.push(obj);
          }
        } else {
          for (let i in this.arr_choosed_card) {
            if (
              this.arr_choosed_card[i].id == item.id ||
              this.arr_choosed_card[i].id == item.homework_id
            ) {
              this.arr_choosed_card.splice(i, 1);
            }
          }
        }
      }
    },
    //判断card 是否存在选中数组内
    card_in_arr(item) {
      let id = item.id || item.homework_id;
      for (let i in this.arr_choosed_card) {
        if (this.arr_choosed_card[i].id == id) {
          return true;
        }
      }
      return false;
    },
    confirm_choose() {
      if (!this.arr_choosed_card.length) {
        this.add_homework_material_dia = false;
        return;
      }

      // if(this.is_typeof_add_to==0){
      this.content_json[this.new_add_type].concat(this.arr_choosed_card);
      for (let i in this.arr_choosed_card) {
        this.arr_choosed_card[i].send_to = this.is_typeof_add_to; //0课前  1课中 2课后
        this.content_json[this.new_add_type].push(this.arr_choosed_card[i]);
      }
      console.log(this.content_json, this.arr_choosed_card);
      // console.log(this.arr_choosed_card)
      // console.log(this.content_json[this.new_add_type])
      // if( this.new_add_type=='courseware'){

      //    this.course_content_type.b.uuid=this.course_content_type.b.uuid.concat(this.arr_choosed_card)

      // }else{
      //   this.course_content_type.b.f=this.course_content_type.b.f.concat(this.arr_choosed_card)
      // }
      // }else
      //  if(this.is_typeof_add_to==1){
      //   if( this.new_add_type=='homework'){
      //      this.course_content_type.m.uuid=this.course_content_type.m.uuid.concat(this.arr_choosed_card)
      //   }else{
      //     this.course_content_type.m.f=this.course_content_type.m.f.concat(this.arr_choosed_card)
      //   }
      // }else
      //  if(this.is_typeof_add_to==2){
      //   if( this.new_add_type=='homework'){
      //      this.course_content_type.a.uuid=this.course_content_type.a.uuid.concat(this.arr_choosed_card)
      //   }else{
      //     this.course_content_type.a.f=this.course_content_type.a.f.concat(this.arr_choosed_card)
      //   }
      // }

      this.add_homework_material_dia = false;
    },
    confirm_choose_teaching() {
      if (this.arr_choosed_card.length) {
        this.teaching_text_name = this.arr_choosed_card[0].name;
        this.teaching_text = this.arr_choosed_card[0].content;
        this.teaching_uuid = this.arr_choosed_card[0].teaching_uuid;
        sessionStorage.teaching_text_uuid = this.arr_choosed_card[0].teaching_uuid;
        this.add_homework_material_dia = false;
        sessionStorage.teaching_text = this.arr_choosed_card[0].content;
        sessionStorage.teaching_text_name = this.arr_choosed_card[0].name;
        sessionStorage.teaching_uuid = this.arr_choosed_card[0].teaching_uuid;
      }
    },
    confirm_choose_guidance() {
      if (this.arr_choosed_card.length) {
        this.course_content_guide_name = this.arr_choosed_card[0].name;
        this.guidance_uuid = this.arr_choosed_card[0].guidance_uuid;
        this.course_content_guide_json = JSON.parse(this.arr_choosed_card[0].content);
        sessionStorage.course_content_guide_name = this.arr_choosed_card[0].name;
        sessionStorage.course_content_guide_json = JSON.stringify(
          this.course_content_guide_json
        );
        sessionStorage.guidance_uuid = this.arr_choosed_card[0].guidance_uuid;
        this.add_homework_material_dia = false;
        this.$forceUpdate();
      }
    },
    //获取资料最里层
    get_material_deep() {
      let arr = [];
      for (let i in this.list_for_choose) {
        if (typeof this.list_for_choose[i].file == "string") {
          this.list_for_choose[i].file = JSON.parse(this.list_for_choose[i].file);
        }
        for (let j in this.list_for_choose[i].file) {
          arr.push({
            heat: this.list_for_choose[i].heat,
            createtime: this.list_for_choose[i].createtime,
            id: this.list_for_choose[i].id + "_" + j,
            teacher_name: this.list_for_choose[i].teacher_name,
            from: this.list_for_choose[i].from,
            type: this.list_for_choose[i].file[j].type,
            name: this.list_for_choose[i].file[j].name || this.list_for_choose[i].name,
            url: this.list_for_choose[i].file[j].url,
            img_list: this.list_for_choose[i].file[j].img_list,
            thumb: this.list_for_choose[i].file[j].img_list || "",
            material_uuid: this.list_for_choose[i].material_uuid,
          });
        }
      }
      this.list_for_choose = arr;
      // console.log(JSON.parse(JSON.stringify(arr)))
    },

    //共享资料
    get_new_data_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var formData = new FormData();
      formData.append("name", this.search_data);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("page_size", 12);
      formData.append("flag", "share_material");
      formData.append("file_type", this.file_type);
      this.axios.post(`/school/bag/sourceBag`, formData).then((res) => {
        if (res.data.code == 1) {
          for (var i in res.data.data.data) {
            if (
              res.data.data.data[i].file != "" &&
              res.data.data.data[i].file != null &&
              res.data.data.data[i].file != undefined
            ) {
              res.data.data.data[i].file = JSON.parse(res.data.data.data[i].file);
            }
            // console.log(res.data.data.data)
            res.data.data.data[i].serial =
              (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            res.data.data.data[i].createtime = res.data.data.data[i].createtime.split(
              " "
            )[0];
          }
          // this.set_classify(res.data.data.data)
          this.list_for_choose = res.data.data.data;
          this.total = res.data.data.count;
          this.get_material_deep();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },

    //获取我的资料收藏列表
    get_my_data_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var formData = new FormData();
      formData.append("flag", "my_material");
      formData.append("file_type", this.file_type);
      formData.append("name", this.search_data);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("page_size", 12);

      this.axios.post(`/school/bag/sourceBag`, formData).then((res) => {
        if (res.data.code == 1) {
          for (var i in res.data.data.data) {
            res.data.data.data[i].file = JSON.parse(res.data.data.data[i].file);
            res.data.data.data[i].serial =
              (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            // res.data.data.data[i].createtime =
            //   res.data.data.data[i].createtime.split(" ")[0];
            //   console.log(res.data.data.data[i].createtime)
          }
          // this.set_classify(res.data.data.data)
          this.list_for_choose = res.data.data.data;
          this.total = res.data.data.count;
          this.get_material_deep();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //获取学校资料列表
    get_school_data_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var school_code = userInfo.school_code;
      var formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("name", this.search_data);
      formData.append("page_size", 12);
      formData.append("flag", "school_material");
      formData.append("file_type", this.file_type);
      this.axios.post(`/school/bag/sourceBag`, formData).then((res) => {
        if (res.data.code == 1) {
          for (var i in res.data.data.data) {
            res.data.data.data[i].file = JSON.parse(res.data.data.data[i].file);
            res.data.data.data[i].serial =
              (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            res.data.data.data[i].createtime = res.data.data.data[i].createtime.split(
              " "
            )[0];
          }
          // this.set_classify(res.data.data.data)
          this.list_for_choose = res.data.data.data;
          this.total = res.data.data.count;
          this.get_material_deep();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //获取云资料列表
    getQuestion(order, sort) {
      // 云端接口 升降序转缩写
      if (order == "ascending") {
        order = "asc";
      } else if (order == "descending") {
        order = "desc";
      }

      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var subject_code = userInfo.subject_code;
      var formData = new FormData();
      var gather = ["a00000", "a00001", "a00002"];
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      // formData.append("sort", 'createtime');
      formData.append("name", this.search_data);
      formData.append("page_size", 12);
      formData.append("subject_code", subject_code);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      formData.append("flag", "cloud_material");
      formData.append("file_type", this.file_type);
      this.axios.post(`/teacher/subject/sourcebag`, formData).then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data.list);
          // this.getQs_total = res.data.data.total;
          this.total = res.data.data.total;
          for (var i in res.data.data.list) {
            // console.log(res.data.data.list[i])
            res.data.data.list[i].serial =
              (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            res.data.data.list[i].createtime = res.data.data.list[i].createtime.split(
              " "
            )[0];
          }
          // this.set_classify(res.data.data.list)
          let questionList = res.data.data.data;
          this.list_for_choose = questionList;
          this.total = res.data.data.total;
          this.get_material_deep();
        } else {
          this.$message({
            type: "error",
            duration: 1500,
            message: res.data.msg,
          });
        }
      });
    },
    //获取云作业列表
    get_work_list(order, sort) {
      //云端接口 升降序转缩写
      if (order == "ascending") {
        order = "asc";
      } else if (order == "descending") {
        order = "desc";
      }
      //获取当前页数
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var gather = ["a00000", "a00001", "a00002"];
      var subject_code = userInfo.subject_code;
      var formData = new FormData();
      formData.append("order", order);
      formData.append("name", this.search_data);
      formData.append("homework_label_id", this.homework_label_id);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("current_page", this.pageNum);
      formData.append("page_size", 12);
      formData.append("subject_code", subject_code);
      // //编码集合
      formData.append("chapter_code", this.chapter_code);
      // //排序字段名称
      // formData.append("sort", "heat");
      // //排序
      // formData.append("order", "desc");
      this.axios.post("/teacher/homework/getlist", formData).then((res) => {
        var list = res.data.data.data;

        for (var i = 0; i < list.length; i++) {
          try {
            list[i].serial = this.getQs_pageNum * (Number(i) + 1);
            list[i].topic_num = JSON.parse(JSON.stringify(list[i].content)).length;
          } catch (error) {
            list[i].topic_num = 0;
          }
        }
        // this.set_classify(list)

        this.list_for_choose = list;
        this.total = res.data.data.count;
        // console.log(res.data.data.total);
      });
    },
    //学校作业
    get_school_job_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var school_code = userInfo.school_code;
      var formData = new FormData();
      formData.append("current_page", this.pageNum);
      formData.append("order", order);
      formData.append("name", this.search_data);
      formData.append("homework_label_id", this.homework_label_id);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("chapter_code", this.chapter_code);
      formData.append("status", 3);
      formData.append("page_size", 12);
      this.axios.post(`/school/Homework/HomeworkList`, formData).then((res) => {
        let school_job_list = res.data.data.data;
        for (var i = 0; i < school_job_list.length; i++) {
          try {
            school_job_list[i].serial = (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            school_job_list[i].topic_num = JSON.parse(
              JSON.stringify(school_job_list[i].content)
            ).length;
          } catch (error) {
            school_job_list[i].topic_num = 0;
          }
        }

        // this.set_classify(school_job_list)
        this.list_for_choose = school_job_list;
        this.total = res.data.data.count;
        // console.log(school_job_list);
        // bus.$emit("studentList", school_job_list);
      });
    },
    //共享作业
    get_new_job_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var formData = new FormData();
      formData.append("current_page", this.pageNum);
      formData.append("chapter_code", this.chapter_code);
      formData.append("status", 2);
      formData.append("name", this.search_data);
      formData.append("homework_label_id", this.homework_label_id);
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("page_size", 12);
      this.axios.post(`/school/Homework/HomeworkList`, formData).then((res) => {
        let new_job_list = res.data.data.data;
        for (var i = 0; i < new_job_list.length; i++) {
          try {
            new_job_list[i].serial = (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
            new_job_list[i].topic_num = JSON.parse(
              JSON.stringify(new_job_list[i].content)
            ).length;
          } catch (error) {
            new_job_list[i].topic_num = 0;
          }
        }
        // this.set_classify(new_job_list)
        this.list_for_choose = new_job_list;
        this.total = res.data.data.count;
      });
    },
    //我的作业
    get_my_job_list(order, sort) {
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      var formData = new FormData();
      formData.append("current_page", this.pageNum);
      formData.append("chapter_code", this.chapter_code);
      formData.append("order", order);
      formData.append("name", this.search_data);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("homework_label_id", this.homework_label_id);
      formData.append("page_size", 12);
      this.axios
        .post(`/school/Collection_homework/collectionList`, formData)
        .then((res) => {
          let my_job_list = res.data.data.data;
          for (var i = 0; i < my_job_list.length; i++) {
            try {
              my_job_list[i].serial = (this.getQs_pageNum - 1) * 10 + (Number(i) + 1);
              my_job_list[i].topic_num = JSON.parse(
                JSON.stringify(my_job_list[i].content)
              ).length;
            } catch (error) {
              my_job_list[i].topic_num = 0;
            }
          }
          // this.set_classify(my_job_list)
          this.list_for_choose = my_job_list;
          this.total = res.data.data.count;
        });
    },
    //封装请求学校教案列表
    get_school_course(order, sort) {
      // return
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      // formData.append("order", order);
      formData.append("order", order || "descending");
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("sort", sort || "heat");
      formData.append("name", this.search_data);
      formData.append("status", this.right_status);
      formData.append("current_page", this.pageNum);
      formData.append("teaching_label_id", this.homework_label_id);
      formData.append("page_size", 12);
      this.axios.post("/school/teaching/teachingList", formData).then((res) => {
        for (var i in res.data.data.data) {
          res.data.data.data[i].serial = (this.pageNum - 1) * 10 + (Number(i) + 1);
        }
        if (res.data.code == 1) {
          this.list_for_choose = res.data.data.data;
          this.total = res.data.data.count;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    get_school_guidance(order, sort) {
      // return
      let formData = new FormData();
      formData.append("chapter_code", this.chapter_code);
      // formData.append("order", order);
      formData.append("order", order || "descending");
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("sort", sort || "heat");
      formData.append("name", this.search_data);
      formData.append("status", this.right_status);
      formData.append("current_page", this.pageNum);
      formData.append("teaching_label_id", this.homework_label_id);
      formData.append("page_size", 12);
      this.axios.post("/school/guidance/guidanceList", formData).then((res) => {
        for (var i in res.data.data.data) {
          res.data.data.data[i].serial = (this.pageNum - 1) * 10 + (Number(i) + 1);
        }
        if (res.data.code == 1) {
          this.list_for_choose = res.data.data.data;
          this.total = res.data.data.count;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //封装请求收藏列表
    get_collection_list(order, sort) {
      let formData = new FormData();
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("name", this.search_data);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      formData.append("teaching_label_id", this.homework_label_id);
      formData.append("page_size", 12);
      this.axios
        .post("/school/Collection_Teaching/collectionList", formData)
        .then((res) => {
          for (var i in res.data.data.data) {
            res.data.data.data[i].serial = (this.pageNum - 1) * 10 + (Number(i) + 1);
          }
          if (res.data.code == 1) {
            this.list_for_choose = res.data.data.data;
            this.total = res.data.data.count;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: 1500,
              showClose: true,
            });
          }
        });
    },
    get_collection_list_guidance(order, sort) {
      let formData = new FormData();
      formData.append("order", order);
      formData.append("sort", sort);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("name", this.search_data);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      // formData.append("teaching_label_id", this.homework_label_id);
      formData.append("page_size", 12);
      this.axios
        .post("/school/Collection_Guidance/collectionList", formData)
        .then((res) => {
          for (var i in res.data.data.data) {
            res.data.data.data[i].serial = (this.pageNum - 1) * 10 + (Number(i) + 1);
          }
          if (res.data.code == 1) {
            this.list_for_choose = res.data.data.data;
            this.total = res.data.data.count;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              duration: 1500,
              showClose: true,
            });
          }
        });
    },

    //获取封装云端接口
    get_teacher_guidance_list(order, sort) {
      //云端接口 升降序转缩写
      if (order == "ascending") {
        order = "asc";
      } else if (order == "descending") {
        order = "desc";
      }
      let formData = new FormData();
      formData.append("page_size", 12);
      formData.append("name", this.search_data);
      formData.append("order", order);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      // formData.append("teaching_label_id", this.homework_label_id);
      formData.append("sort", sort);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      this.axios.post("/teacher/guidance/getlist", formData).then((res) => {
        // console.log(res)
        if (res.data.code == 1) {
          this.list_for_choose = res.data.data.list;
          this.total = res.data.data.total;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    get_teacher_course_list(order, sort) {
      //云端接口 升降序转缩写
      if (order == "ascending") {
        order = "asc";
      } else if (order == "descending") {
        order = "desc";
      }
      let formData = new FormData();
      formData.append("page_size", 12);
      formData.append("name", this.search_data);
      formData.append("order", order);
      formData.append("start_time", this.starttime_sort);
      formData.append("end_time", this.end_time_sort);
      formData.append("teaching_label_id", this.homework_label_id);
      formData.append("sort", sort);
      formData.append("chapter_code", this.chapter_code);
      formData.append("current_page", this.pageNum);
      this.axios.post("/teacher/teaching/getlist", formData).then((res) => {
        // console.log(res)
        if (res.data.code == 1) {
          this.list_for_choose = res.data.data.list;
          this.total = res.data.data.total;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            duration: 1500,
            showClose: true,
          });
        }
      });
    },

    handleFileDownload(url, filename) {
      // 创建 a 标签
      let a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    },
    handlePdfLink(url, filename) {
      this.$message({
        message: "正在下载",
        type: "success",
        duration: 1500,
        showClose: true,
      });
      // console.log(url,filename)
      fetch(url, {
        method: "get",
        responseType: "arraybuffer",
      })
        .then(function (res) {
          if (res.status !== 200) {
            return res.json();
          }
          return res.arrayBuffer();
        })
        .then((blobRes) => {
          // 生成 Blob 对象，设置 type 等信息
          const e = new Blob([blobRes], {
            type: "application/octet-stream",
            "Content-Disposition": "attachment",
          });
          // 将 Blob 对象转为 url
          const link = window.URL.createObjectURL(e);
          this.handleFileDownload(link, filename);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    isDownloading() {
      this.$message({
        message: "处理中",
        type: "success",
        duration: 1500,
        showClose: true,
      });
    },
    changeurl(item) {
      this.previewVideoUrl =
        JSON.parse(sessionStorage.userInfo).school.server_url + item.url;
    },
    changeurl_img(item) {
      this.srcList_img = JSON.parse(sessionStorage.userInfo).school.server_url + item.url;
    },
    change(item) {
      this.Isactive = item.active;
      this.s_name = item.name;
      if (this.s_name == "私有") {
        this.status_course = true;
      } else if (this.s_name == "公有") {
        this.status_course = false;
      }
    },
    //选择标签类型
    // label_change(){
    //   console.log(this.current_label)
    //   this
    // },
    //获取全部类型
    get_data_all_type() {
      let formData = new FormData();
      if (sessionStorage.userInfo) {
        formData.append("subject_code", JSON.parse(sessionStorage.userInfo).subject_code);
      }
      this.axios.post(`/teacher/course/getcourselabel`, formData).then((res) => {
        if (res.data.code == 1) {
          var arr_list = [{ name: "全部", id: "" }];
          for (var i = 0; i < res.data.data.length; i++) {
            arr_list.push(res.data.data[i]);
          }
          this.options_label = arr_list;
          this.current_label = this.$route.query.label;
          // console.log(arr_list)
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },

    //预览
    preview(i, item) {
      for (var i = 0; i < this.srcList.length; i++) {
        if (this.srcList[i] == item) {
          if (i > 0) {
            var end = this.srcList.slice(0, i);
            var star = this.srcList.slice(i);

            this.srcList = star.concat(end);
          }
        }
      }
    },
    //取消
    resetForm(form) {
      this.visible = false;
      this.$refs[form].resetFields();
      // this.slect_class_arr = [];
      // this.slect_grouping_arr = [];
    },
    //修改名称
    change_name() {
      this.$prompt("请输入备课包名字", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: this.course_name,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          this.course_name = value;

          var course_obj = JSON.parse(sessionStorage.course_new_obj);
          course_obj.courseName = value;

          sessionStorage.course_new_obj = JSON.stringify(course_obj);
        })
        .catch(() => {});
    },
    torich_guidance() {
      let that = this;
      // console.log(this.guidance_text)

      // setTimeout(function() {
      //   bus.$emit("app_course_new_send_type", that.guidance_text);
      // }, 100);
      sessionStorage.guidance_text = that.guidance_text;
      sessionStorage.app_course_new_send_type = "guidance_text";

      sessionStorage.removeItem("course_content_guide_name");
      sessionStorage.removeItem("course_content_guide_json");
      this.$router.push({
        path: "/course/sign_course_edit_rich_guide",
        query: { course_name: this.course_name_text },
      });
    },
    tochoose_guidance() {
      this.$router.push({
        path: "/sign_learning_guide_choose",
      });
    },
    tochoose_teaching() {
      this.$router.push({
        path: "/sign_teaching_case_choose",
      });
    },

    torich_teaching() {
      //是否预览
      if (this.$route.query.name == "预览") {
        this.dialogVisible_previewData = true;
        this.prew_type = "teaching";
        this.prew_content = {
          content: this.teaching_text,
          name: this.teaching_text_name,
        };
        return;
      }

      let that = this;

      sessionStorage.teaching_text = that.teaching_text;
      sessionStorage.teaching_text_name = that.teaching_text_name;

      sessionStorage.app_course_new_send_type = "teaching_text";
      if (this.$route.query.from == "index") {
        that.$router.push({
          path: "/course/sign_course_edit_rich",
          query: { course_name: this.course_name_text, from: "index" },
        });
      } else {
        that.$router.push({
          path: "/course/sign_course_edit_rich",
          query: { course_name: this.course_name_text },
        });
      }
    },
    show_save_course() {
      //  console.log(this.course_content_type)
    },
    save_course() {
      if (!this.course_name) {
        this.$message({
          type: "error",
          message: "请填写备课包名称",
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      if (!this.chapter_code) {
        this.$message({
          type: "error",
          message: "请选择章节",
          durtion: 1500,
          showClose: true,
        });
        return;
      }
      this.course_content_type = {
        b: { uuid: [], f: [], exam: [] },
        m: { uuid: [], f: [], exam: [] },
        a: { uuid: [], f: [], exam: [] },
      };
      console.log(this.content_json);
      let content_json = this.content_json;
      for (let i in content_json.courseware) {
        content_json.courseware[i].type_from = "courseware";
        if (content_json.courseware[i].send_to == 0) {
          this.course_content_type.b.f.push(content_json.courseware[i]);
        } else if (content_json.courseware[i].send_to == 1) {
          this.course_content_type.m.f.push(content_json.courseware[i]);
        } else if (content_json.courseware[i].send_to == 2) {
          this.course_content_type.a.f.push(content_json.courseware[i]);
        }
      }
      for (let i in content_json.homework) {
        content_json.homework[i].type_from = "homework";
        if (content_json.homework[i].send_to == 0) {
          this.course_content_type.b.uuid.push(content_json.homework[i]);
        } else if (content_json.homework[i].send_to == 1) {
          this.course_content_type.m.uuid.push(content_json.homework[i]);
        } else if (content_json.homework[i].send_to == 2) {
          this.course_content_type.a.uuid.push(content_json.homework[i]);
        }
      }
      for (let i in content_json.video) {
        content_json.video[i].type_from = "video";
        if (content_json.video[i].send_to == 0) {
          this.course_content_type.b.f.push(content_json.video[i]);
        } else if (content_json.video[i].send_to == 1) {
          this.course_content_type.m.f.push(content_json.video[i]);
        } else if (content_json.video[i].send_to == 2) {
          this.course_content_type.a.f.push(content_json.video[i]);
        }
      }
      for (let i in content_json.material) {
        content_json.material[i].type_from = "material";
        if (content_json.material[i].send_to == 0) {
          this.course_content_type.b.f.push(content_json.material[i]);
        } else if (content_json.material[i].send_to == 1) {
          this.course_content_type.m.f.push(content_json.material[i]);
        } else if (content_json.material[i].send_to == 2) {
          this.course_content_type.a.f.push(content_json.material[i]);
        }
      }
      let tiku_uuids = [];
      let material_uuids = [];
      let material_sub_num = 0;
      for (var i in this.course_content_type.b.uuid) {
        tiku_uuids.push({
          uuid:
            this.course_content_type.b.uuid[i].homework_uuid ||
            this.course_content_type.b.uuid[i].uuid,
          name: this.course_content_type.b.uuid[i].title,
          type: "b",
        });
      }
      for (var i in this.course_content_type.m.uuid) {
        tiku_uuids.push({
          uuid:
            this.course_content_type.m.uuid[i].homework_uuid ||
            this.course_content_type.b.uuid[i].uuid,
          name: this.course_content_type.m.uuid[i].title,
          type: "m",
        });
      }
      for (var i in this.course_content_type.a.uuid) {
        tiku_uuids.push({
          uuid:
            this.course_content_type.a.uuid[i].homework_uuid ||
            this.course_content_type.b.uuid[i].uuid,
          name: this.course_content_type.a.uuid[i].title,
          type: "a",
        });
      }
      for (var i in this.course_content_type.b.f) {
        material_uuids.push({
          uuid: this.course_content_type.b.f[i].material_uuid,
          name: this.course_content_type.b.f[i].name,
        });
        material_sub_num++;
      }
      for (var i in this.course_content_type.m.f) {
        material_uuids.push({
          uuid: this.course_content_type.m.f[i].material_uuid,
          name: this.course_content_type.m.f[i].name,
        });
        material_sub_num++;
      }
      for (var i in this.course_content_type.a.f) {
        material_uuids.push({
          uuid: this.course_content_type.a.f[i].material_uuid,
          name: this.course_content_type.a.f[i].name,
        });
        material_sub_num++;
      }
      // console.log(material_sub_num)
      // return
      this.course_content_type.teaching_name = this.teaching_text_name || "";
      this.course_content_type.guidance_name = this.course_content_guide_name || "";

      let formData = new FormData();
      if (sessionStorage.course_add_type == "new" && this.$route.query.from != "index") {
        let obj = JSON.parse(sessionStorage.course_new_obj);
        formData.append("chapter_code", obj.chapter_code);
      } else {
        formData.append("chapter_code", this.chapter_code); //////////////改
      }
      formData.append("name", this.course_name);
      formData.append("from", JSON.parse(sessionStorage.userInfo).school.name);
      formData.append("school_code", JSON.parse(sessionStorage.userInfo).school_code);
      formData.append("content", JSON.stringify(this.course_content_type));
      formData.append("material_sub_num", material_sub_num);

      formData.append("remark", 1);
      formData.append("textbook_guid", sessionStorage.text_book_guid);
      // if (!this.status_value) {
      //   if (this.userInfo.power == 2) {
      //   formData.append("status", 3);
      // } else {
      //   formData.append("status", this.status_course == false ? 2 : 1);
      // }

      // } else {
      //         if (this.userInfo.power == 2) {
      //     formData.append("status", 3);
      //   } else {
      //     formData.append("status", 2);
      //   }
      // }
      formData.append("status", 1);
      formData.append("teaching", this.teaching_text ? this.teaching_text : "");
      formData.append(
        "teaching_name",
        this.teaching_text_name ? this.teaching_text_name : ""
      );
      formData.append(
        "guidance_name",
        this.course_content_guide_name ? this.course_content_guide_name : ""
      );
      if (typeof this.course_content_guide_json == "string") {
        formData.append("guidance", this.course_content_guide_json);
      } else {
        formData.append("guidance", JSON.stringify(this.course_content_guide_json));
      }

      formData.append("teaching_uuid", this.teaching_uuid);
      formData.append("guidance_uuid", this.guidance_uuid);
      formData.append("course_label_id", this.current_label || "");
      formData.append("teacher_name", JSON.parse(sessionStorage.userInfo).name);
      if (this.status_value) {
        if (this.status_to_examine) {
          formData.append("approval_status", 30);

          formData.append("share_status", this.status);
        } else {
          formData.append("approval_status", 20);
        }
      } else {
        formData.append("approval_status", 0);
      }

      if (!this.add_byheat) {
        if (this.$route.query.from == "index") {
          formData.append("group_id", this.$route.query.group_id);
        }
        this.axios.post("/school/course/addCourse", formData).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
            if (this.$route.query.from == "research") {
              this.$router.push({
                name: "/research_class_detail",
                params: {
                  type: 2,
                  uuid: this.$route.query.research_uuid,
                },
              });
            } else {
              if (this.status_value) {
                this.$router.push("/myResource");
              } else {
                this.$router.push("/resource");
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
      } else {
        formData.append("id", this.course_id);
        formData.delete("status");
        this.axios.post("/school/course/editCourse", formData).then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });

            if (this.status_value) {
              this.$router.push("/myResource");
            } else {
              this.$router.push("/resource");
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 1500,
              showClose: true,
            });
          }
        });
      }
    },
    //返回
    prevs() {
      this.$router.go(-1);
    },
    //选中课中。。。
    newactive: function (type) {
      //  console.log(type)
      //  console.log(this.course_content)
      let that = this;
      let course_content = that.course_content;
      that.type = type;
      //  setTimeout(() => {

      //  }, 100);
      var type;
      if (type == "course_before") {
        type = "课前";
      } else if (type == "course_mount") {
        type = "课中";
      } else if (type == "course_after") {
        type = "课后";
      }

      that.$router.push({
        path: "/course/sign_course_choose",
        query: { name: type },
      });
      // this.del = "新增";
      // this.Isthickness = false;
      // console.log(this.del);
      // console.log(this.Isthickness);
      // this.$emit("sendadd", this.del, this.Isthickness);
    },
    del: function () {
      this.Isshow = false;
    },
    rename_exam(item, type) {
      let now_job;
      if (type == "b") {
        now_job = this.course_content.b.exam;
      } else if (type == "m") {
        now_job = this.course_content.m.exam;
      } else if (type == "a") {
        now_job = this.course_content.a.exam;
      }
      this.rename_fz(now_job, item, item.name, "exam");
    },
    //封装修改作业名
    rename_fz(now_job, item, title, type) {
      let title_temp, title1_temp;
      if (type == "job") {
        (title_temp = "请输入作业名称"), (title1_temp = "修改作业名称");
      } else {
        (title_temp = "请输入资料名称"), (title1_temp = "修改资料名称");
      }
      this.$prompt(title_temp, title1_temp, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: title,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          for (var i in now_job) {
            if (now_job[i].id == item.id) {
              type == "job" ? (now_job[i].title = value) : (now_job[i].name = value);
            }
          }
          // let formData = new FormData();
          // formData.append("id", sessionStorage.course_new_courseId);
          // formData.append("content", JSON.stringify(this.course_content));
          // this.axios
          //   .post("/school/course/editCourse", formData)
          //   .then(res => {});
        })
        .catch(() => {});
    },
    //重命名
    rename_job(item, type) {
      let now_job;
      if (type == "b") {
        now_job = this.course_content.b.uuid;
      } else if (type == "m") {
        now_job = this.course_content.m.uuid;
      } else if (type == "a") {
        now_job = this.course_content.a.uuid;
      }
      this.rename_fz(now_job, item, item.title, "job");
    },
    rename_f(item, type) {
      let now_job;
      if (type == "b") {
        now_job = this.course_content.b.f;
      } else if (type == "m") {
        now_job = this.course_content.m.f;
      } else if (type == "a") {
        now_job = this.course_content.a.f;
      }
      this.rename_fz(now_job, item, item.name, "f");
    },

    //封装删除
    del_fz(now_job, item, type, index) {
      // console.log(type);
      let tip;
      if (type == "f") {
        tip = "资料 " + item.name;
      } else {
        tip = "作业 " + item.title;
      }
      this.$confirm("删除 " + tip + " , 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log(JSON.parse(JSON.stringify(now_job)));
          // console.log(JSON.parse(JSON.stringify(item)));
          // for (var i=0;i < now_job.length; i++) {
          //   if (now_job[i].id == item.id) {
          //     now_job.splice(i, 1);
          //     i--
          //   }
          // }
          now_job.splice(index, 1);
          // let formData = new FormData();
          // formData.append("id", sessionStorage.course_new_courseId);
          // formData.append("content", JSON.stringify(this.course_content));
          // this.axios
          //   .post("/school/course/editCourse", formData)
          //   .then(res => {});
        })
        .catch(() => {});
    },
    //删除
    del_job(item, type, index) {
      let now_job;
      if (type == "b") {
        now_job = this.course_content.b.uuid;
      } else if (type == "m") {
        now_job = this.course_content.m.uuid;
      } else if (type == "a") {
        now_job = this.course_content.a.uuid;
      }
      this.del_fz(now_job, item, "job", index);
    },
    del_f(item, type) {
      let now_job;
      if (type == "b") {
        now_job = this.course_content.b.f;
      } else if (type == "m") {
        now_job = this.course_content.m.f;
      } else if (type == "a") {
        now_job = this.course_content.a.f;
      }
      this.del_fz(now_job, item, "f");
    },

    //封装预览
    preview_fz() {},
    //预览
    preview_job(item, type) {
      // console.log(item.homework_uuid||item.uuid);
      let uuid = item.homework_uuid || item.uuid;
      // console.log(JSON.parse(item.content));
      // this.$router.push({
      //   path: "/job/sgin_job_preview",
      //   query: { title: item.title, chapter_code: item.chapter_code }
      // });

      // console.log(item.homework_uuid)
      this.axios.post("/school/Homework/detail?uuid=" + uuid).then((res) => {
        if (res.data.code == 1) {
          sessionStorage.preview_new_titleList_is = JSON.stringify(res.data.data.data);

          sessionStorage.preview_new_titleList_title_is = item.title || item.name;
          this.$store.state.data_save_topic = false;
          this.$router.push({
            path: "/job/sign_job_preview_new_is",
            query: { name: "预览" },
          });
        }
      });
    },
    preview_f(item, type) {
      // console.log(item);
      this.dialogVisible = true;
      this.data_dataList = JSON.parse(item.file);
      // console.log(this.data_dataList)
      // var arr = [];
      // if (item.file_type == "mp3") {
      //   this.visible = true;
      //   this.widow_title = "预览音乐";
      //   this.audio = item.file;
      // } else if (item.file_type == "mp4") {
      //   this.widow_title = "预览视频";
      //   this.visible = true;
      //   this.video = this.item.file;
      // } else {
      //   this.widow_title = "预览图片";
      //   this.visible = true;
      //   var srcList = item.file.split(",");
      //   for (var i = 0; i < srcList.length; i++) {
      //     arr.push(
      //       JSON.parse(sessionStorage.userInfo).school.server_url + srcList[i]
      //     );
      //   }

      //   this.srcList = arr;

      // this.url = this.srcList[0];
      // console.log(this.srcList);
      // console.log(this.url);
      // var img_url = this.userInfo.school.server_url + url;
      // this.showImg(arr);
      // }
      // console.log(type);
      // let imgurl =
      //   JSON.parse(sessionStorage.userInfo).school.server_url + item.file;
      // if (item.file_ext_txt == "图片") {
      //   this.$alert('<image src="' + imgurl + '"/>', "HTML 片段", {
      //     dangerouslyUseHTMLString: true
      //   }).catch(() => {});
      // } else {
      // }
    },

    send: function () {},
    btnall: function (command) {
      this.name = command;
    },
    getParent: function () {},
  },
  beforeDestroy() {
    let that = this;
    // bus.$off("get_courese_send");
    // bus.$off("send_editor");
    sessionStorage.course_content = JSON.stringify(that.course_content);
    sessionStorage.content_json = JSON.stringify(that.content_json);
    sessionStorage.course_type = that.type;
    sessionStorage.course_content_course_name = that.course_name;
    // setTimeout(function() {
    //   bus.$emit("questionList_qs_edit", that.questionList, that.to_edit_index);
    // }, 1500);
  },
};
</script>

<style>
.dialogVisible_add_material {
  border-radius: 20px;
}
.dialogVisible_add_material .el-dialog__footer {
  text-align: center;
}
.dialogVisible_add_material .el-dialog__footer .el-button {
  margin: 0 50px;
}
.add_course_info_head_course_name_add_name .el-input__inner {
  border-color: transparent !important;
  background: #f3f3f3;
  border-radius: 20px 0px 20px 2px;
  text-align: center;
  font-size: 14px !important;
  height: 40px !important;
}
.add_course_info_head_course_name_add_name.el-checkbox__label {
  font-size: 12px !important;
}
.area_popper_course_add .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course_add {
  border-color: #ff9b36;
  width: 88px !important;
  /* height: 400px; */
  padding-right: 0;
  min-width: 88px !important;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}
.area_popper {
  border-color: #ff9b36;
  width: 300px;
  height: 400px;
  padding-right: 0;
  overflow: auto;
  font-size: 16px;
  line-height: 16px;
}
.course_search .el-input-group__append {
  border-radius: 0 20px 20px 0;
}
.course_search .el-input__inner {
  border-radius: 20px 0 0 20px;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 14px !important;
}
.course_search .el-input {
  height: 40px;
}
.el-dialog__body {
  padding-top: 10px;

  /* padding: 15px 50px; */
}
.sign_course_edit_rich_guide_dia {
  border-radius: 20px;
  width: 1199px;
  /* height: 75vh; */
  /* margin-top: calc(50vh - 350px) !important; */
}
.sign_course_edit_rich_guide_dia_prew {
  height: 75vh;
}
.el-pagination {
  text-align: right;
}
</style>
<style scoped>
.wrapper {
  margin: 14px auto;
  background: #ffffff;
  height: calc(100vh - 152px);
  overflow: auto;
  border-radius: 12px;
  width: 75vw;
  /* padding:20px 0; */
}
.add_course_head {
  padding: 0 20px;
  height: 32px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 17px;
}
.add_course_head img {
  display: block;
  width: 24px;
  height: 20px;
  cursor: pointer;
}
.add_course_head_save {
  display: flex;
}
.add_course_head_save > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  height: 32px;
  line-height: 32px;
  text-align: center;
  box-sizing: border-box;
  background: #69b4ff;
  border-radius: 8px;
  padding: 0 10px;
  cursor: pointer;
}
.add_course_head_save > div:nth-of-type(1) {
  /* margin-right: 30px; */
}
.add_course_info_head {
  margin: 26px 20px;
}
.add_course_info_head_course_name {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  height: 40px;
  line-height: 40px;
}
.add_course_info_head_course_name_add_name > div:nth-of-type(1) {
  width: 120px;
}
.add_course_info_head_course_name_add_teaching_guide > div:nth-of-type(1) {
  width: 120px;
}
.add_course_info_head_course_name_add_teaching_guide {
  display: flex;
  margin: 26px 0;
}
.add_course_info_head_course_name_myself {
  font-size: 12px !important;
}
.add_course_info_head_course_name_add_teaching_guide > div:nth-of-type(2) {
  height: 32px;
  background: #ff9b36;
  border-radius: 10px;
  padding: 0 20px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.add_course_info_head_course_name_add_teaching_guide > div:nth-of-type(3) {
  height: 32px;
  background: #69b4ff;
  border-radius: 10px;
  padding: 0 20px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  margin-left: 35px;
  cursor: pointer;
}
.add_course_info_content {
  margin: 16px 18px 16px 16px;
}
.add_course_info_content_box {
  /* min-height: 200px; */
  background: #f3f3f3;
  border-radius: 20px 6px 20px 6px;
  position: relative;
  padding: 12px 23px;
  margin: 15px 0;
}
.add_course_info_content_box_head {
  display: flex;
  justify-content: space-between;
}
.add_course_info_content_box_head_operation {
  display: flex;
}
.add_course_info_content_box_head_operation > div {
}
.add_course_info_content_box_head_operation > div:nth-of-type(2) {
  background: #69b4ff;
  height: 32px;
  border-radius: 10px;
  /* padding: 0 20px; */
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  margin-left: 35px;
  cursor: pointer;
}
.add_course_info_content_box_logo {
  position: absolute;
  top: -8px;
  left: 22px;
}
.add_course_info_content_box_head_operation_add {
  height: 32px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  padding: 0 20px;
}
.add_course_info_content_box_head_operation_add_add {
  height: 32px;
  background: #69b4ff;
  border-radius: 10px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  padding: 0 20px;
}
.add_course_info_content_box_head_operation_add_operation > div {
  cursor: pointer;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.add_course_info_content_box_head_operation_add_operation > div:hover {
  color: #ff9b36;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
  position: relative;
}
.send_to_type {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 9;
  width: 36px;
  height: 24px;
  border-radius: 12px 0 8px 0;
  background: #ff9b36;
  color: white;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 0px 0;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}
/* .add_course_info_content_box_content_item_img_homework{
      display: block;
      width: 43px;
      height: 35px;
      margin: 32px auto;
    } */
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 42px;
  height: 42px;
  margin: 28px auto;
}
.add_course_info_content_box_content_item_img_teaching {
  display: block;
  width: 44px;
  height: 47px;
  margin: 26px auto;
}

.add_course_info_content_box_content_item_txt {
  width: 120px;
  /* height: 35px; */
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
.had_content_toEdit_title {
  height: 37px;
  line-height: 37px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.had_content_toEdit_title span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

/* 添加 作业资料教案*/
.add_dia_type_bar {
  display: flex;
}

.add_dia_type_bar_type {
  display: flex;
  height: 46px;
  background: #f3f3f3;
  border-radius: 8px;
  width: 100%;
  /* width: 860px; */
  justify-content: space-between;
  line-height: 26px;
  padding: 10px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.add_dia_type_bar_type_underline {
  width: 36px;
  height: 5px;
  background: #54a9fd;
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 5px;
}
.add_dia_type_bar_type_item {
  cursor: pointer;
}
.add_dia_type_bar_addNew {
  height: 36px;
  background: #ff9b36;
  border-radius: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 36px;
  padding: 0 20px;
  cursor: pointer;
  margin: 5px 0;
  margin-left: auto;
}
.add_dia_search_bar {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
}
.sort_box {
  display: flex;
}
.course_creat_sort {
  margin-left: 20px;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}
.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}
.color_active {
  color: #ff9b36 !important;
}
.course_creat_sort_btn {
  height: 36px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  border: 1px solid #ff9b36;
  color: #ff9b36;
}
.add_dia_foot {
  height: 36px;
  width: 393px;
  display: flex;
  justify-content: space-between;
  margin: 20px auto;
  margin-top: 0;
  margin-bottom: 0;
}
.add_dia_foot > div {
  height: 36px;
  background: #69b4ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  line-height: 36px;
  text-align: center;
  padding: 0 26px;
  border-radius: 10px;
}
.add_dia_foot > div:nth-of-type(2) {
  background: #dddddd;
  color: #999999;
}
.course_page {
  margin-top: 10px;
}
.add_dia_all {
  display: flex;
  flex-direction: column;
  height: calc(75vh - 80px);
}
.add_dia_content {
  /* background:red; */
  /* height: calc( 75vh - 285px); */

  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.course_card {
  width: 238px;
  height: 149px;
  border: 3px solid #69b4ff;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 6px 20px 20px 6px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  margin-right: 50px;
  margin-top: 20px;
  position: relative;
  cursor: pointer;
}
/* .course_card{
    height: 280px;
    width: 240px;
    border: 4px solid #69B4FF;
    box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
    border-radius: 6px 20px 20px 6px;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding:10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  } */
.course_card:nth-of-type(4n) {
  margin-right: 0px;
}
.course_card_title {
  height: 30px;
  line-height: 20px;
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}
.course_card_title_icon img {
  display: block;
}
.course_card_title_name {
  /* width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
    font-size: 16px; */
  width: 130px;
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
  margin-left: 10px;
  font-size: 16px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.course_card_title_course_heat {
  display: flex;
  color: #ff3b47;
  margin-left: auto;
}
.course_card_title_course_heat img {
  display: block;
  height: 16px;
  margin: 3.5px 0;
  margin-right: 3px;
}
.course_card_content_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.course_card_operation {
  display: flex;
  justify-content: space-between;
}
.course_card_operation_item {
  cursor: pointer;
}
.course_card_operation_item img {
  display: block;
}

.course_card_empty {
  background: url(../../assets/images/course_2.0/老师.png);
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200px auto;
}
.choose_card {
  position: absolute;
  width: 20px;
  height: 20px;
  right: -8px;
  top: -8px;
  font-size: 22px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  color: transparent;
  border: 1px solid #69b4ff;
  line-height: 18px;
  text-align: center;
  box-sizing: border-box;
  display: block;
  text-indent: -2px;
}
.add_course_info_content_box_content_item_box {
  display: flex;
  flex-wrap: wrap;
}
.add_material_contnet {
  padding: 0 20px;
}
.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}
.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}
.add_material_content_btn {
  margin: 10px 0;
}
.uploader-drop {
  border: 0 !important;
  background-color: transparent;
  padding: 0;
  margin: 0 0 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.edit_material_item_type_name {
  margin-bottom: 20px;
}

/* 新版 */
.add_file_box {
  /* min-height: 270px; */
  background: #f3f3f3;
  border-radius: 20px 6px 20px 6px;
  position: relative;
  padding: 12px 23px;
  margin: 15px 0;
}
.file_box_head {
  display: flex;
  justify-content: space-between;
}
.file_box_head div:nth-of-type(1) {
  /* font-size: 18px; */
}
.file_box_head div:nth-of-type(2) {
  color: #ff9b36;
  cursor: pointer;
}
.chapter_bar {
  height: 16px;
  /* font-size: 16px; */
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  font-size: 16px;
  padding: 10px;
  cursor: pointer;
  background: #f8f8f8;
  line-height: 16px;
  border-radius: 10px;
  margin-top: 2px;
}
.creat_course {
  width: 78px;
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}
.newBtn {
  width: 50px;
  height: 80px;
  background: #ff9b36;
  color: #ffffff;
  writing-mode: vertical-rl;
  border-radius: 8px;
  letter-spacing: 10px;
  margin-right:10px;
}
.newBtn2 {
  width: 50px;
  height: 80px;
  background: #69b4ff;
  writing-mode: vertical-rl;
  color: #ffffff;
  border-radius: 8px;
  letter-spacing: 10px;
}
</style>
